import common from './common'
import featuresPay from './feature'

const pt = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Produto/Variantes",
        serialNumber: "Número de Série",
        noProductsFound: "Nenhum produto encontrado",
        searchByProductSku: "Pesquisar por produto/SKU",
        searchSerialNumbers: "Pesquisar números de série",
        transactionDetails: "Detalhes da Transação",
        notAvailable: "N/D",
        mainWarehouse: "Armazém Principal"
    },
    new_build_banner: {
        title: 'Nova versão:',
        is_available: 'já está disponível',
        fallback_title: 'Uma nova versão do aplicativo está disponível',
        desc: 'Atualize para obter os recursos e melhorias mais recentes.',
        refreshing: 'Atualizando…',
        refresh_now: 'Atualizar agora',
        later: 'Depois',
        you_are_on: "você está em"
    },
    short: {
        finance: 'Finanças',
        stock: 'Estoque'
    },

    onboarding: {
        welcome: 'Bem-vindo!',
        step: {
            product: {
                totalBreakdown: 'Discriminação total',
                overallFulfilment: 'Cumprimento geral',
                totalShippedQty: 'Qtd. total enviada',
                totalReceivedQty: 'Qtd. total recebida',
                totalOrderedQty: 'Qtd. total encomendada',
                totalShippedOrdered: 'Total enviado / encomendado',
                totalReceivedOrdered: 'Total recebido / encomendado',
                viewQty: 'Ver quantidade',
                fetchingQty: 'A obter detalhes da quantidade...',
                noStockInfo: 'Nenhuma informação de stock encontrada',
                title: '65% Concluído',
                description: 'Faltam apenas 2 passos para começar seu grande sucesso!',
                Warehouse: "Armazém",
            },
            stock: {
                title: '95% Quase Concluído!!',
                description: 'Apenas mais um passo para começar seu grande sucesso! Finalize agora.'
            }
        },
        business: {
            title: 'Negócio criado com sucesso!',
            description: 'Ótimo! Seu negócio foi registrado'
        },
        product: {
            title: 'Adicione seu primeiro produto',
            description: 'Adicione um produto para começar a registrar o estoque',
            Warehouse: "Armazém",
        },
        stock: {
            title: 'Experimente adicionar estoque',
            description: 'Comece a registrar entradas e saídas de estoque'
        },
        action: {
            add_business: {
                title: 'Criar Negócio',
                description: 'Quer criar um novo negócio? Clique aqui'
            },
            join_business: {
                title: 'Juntar-se a um Negócio',
                description: 'Tem um código de convite? Junte-se aqui'
            }
        }
    },

    business: {
        title: 'Selecione um negócio, crie um novo ou junte-se',
        add_business: {
            title: 'Criar novo negócio',
            name: 'Nome do negócio',
            name_placeholder: 'Digite o nome',
            category: 'Categoria do negócio',
            category_placeholder: 'Selecione a categoria',
            button: 'Criar Negócio'
        },
        edit_business: {
            title: 'Editar negócio'
        },
        join_business: {
            title: 'Juntar-se a um Negócio',
            input_code: 'Digite o código de convite abaixo:',
            field_placeholder: 'Código de convite',
            confirm_title: 'Juntar-se',
            confirm_text: 'Você fará parte da equipe em '
        },
        no_business: 'Nenhum negócio disponível',
        create_or_join: 'Crie ou junte-se a um negócio',
        message: {
            saved: 'Negócio salvo com sucesso!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Transações de estoque negativo',
            isNegativeTransactionDisabledHint: 'Ao ativar esta opção, você pode evitar transações que resultariam em estoque negativo.',
            negativeStockError: 'As transações de estoque negativo estão desativadas'
        }
    },

    profile: {
        edit_profile: {
            title: 'Editar perfil',
            name: 'Nome Completo',
            name_placeholder: 'Digite o nome completo',
            email: 'E-mail',
            phone_number: 'Número de Telefone'
        },
        message: {
            required_name: 'O nome é obrigatório'
        }
    },

    product: {
        weightedAverageCost: 'Custo Médio Ponderado',
        weightedAverageValueLabel: 'Valor Médio Ponderado',
        Product: 'Produto',
        hideZeroStock: 'Ocultar estoque zero',
        allVariants: 'Todas as variantes',
        choose_product: 'Escolher Produto',
        choose_product_empty: 'Selecione o produto e insira a quantidade',
        choose_product_empty_manufacturing: 'Selecione o produto e insira a quantidade de fabricação',
        search: {
            placeholder: 'Pesquisar por nome',
            tooltip: 'Abrir scanner',
            Warehouse: "Armazém",
        },
        column: {
            image: 'Foto',
            name: 'Nome',
            price: 'Preço',
            buying_price: 'Preço de Custo',
            selling_price: 'Preço de Venda',
            sku: 'SKU',
            stock: 'Estoque',
            quantity: 'Quantidade',
            latest_stock: 'Restante',
            product_deleted: 'Produto foi excluído',
            info_not_found: 'Informação não disponível',
            expired_date: 'Data de Validade',
            invoice: 'Fatura'
        },
        no_product: 'Nenhum Produto Disponível',
        no_product_subtitle: 'Adicione seu primeiro produto para começar a acompanhar o estoque, preços e vendas.',
        create_first_product: 'Crie seu primeiro produto',
        add_product: {
            sku: 'Código do Produto',
            sku_placeholder: 'Código do Produto. Exemplo: 12345',
            name: 'Nome do Produto',
            name_placeholder: 'Digite o Nome do Produto',
            initial_stock: 'Estoque Inicial',
            initial_stock_placeholder: 'Digite o Estoque Inicial',
            buying_price: 'Preço de Custo',
            buying_price_placeholder: 'Digite o Preço de Custo',
            selling_price: 'Preço de Venda',
            selling_price_placeholder: 'Digite o Preço de Venda',
            category: 'Categoria',
            category_placeholder: 'Selecione a Categoria',
            add_selling_price: 'Adicionar Preço de Atacado',
            expired_date: 'Data de Validade',
            expired_date_placeholder: 'Selecione a Data',
            description: 'Descrição',
            description_placeholder: 'Digite a Descrição',
            custom_label: 'Atributo',
            custom_label_placeholder: 'Digite a Chave',
            add_custom_label: 'Adicionar Mais Atributos',
            Warehouse: "Armazém",
        },
        customerLabel: {},
        choose_selling_price: 'Escolher Preço de Venda',
        selling_price: 'Preço de Venda',
        total_product: 'Total de Produtos',
        total_quantity: 'Estoque Total',
        total_buying_price: 'Preço de Custo Total',
        total_selling_price: 'Preço de Venda Total',
        message: {
            required_name: 'O nome do produto é obrigatório',
            required_sku: 'O SKU é obrigatório',
            required_category: 'O SKU é obrigatório',
            required_quantity: 'O estoque inicial é obrigatório',
            invalid_input_qty: 'Quantidade de estoque inválida',
            required_buying_price: 'O preço de custo é obrigatório',
            required_selling_price: 'O preço de venda é obrigatório',
            required_selling_price_name: 'O nome do preço de venda é obrigatório',
            required_selling_price_price: 'O preço de venda é obrigatório'
        },
        viewMore: 'Ver Mais',
        WarehouseDetails: 'Detalhes do Armazém',
        WarehouseName: 'Nome do Armazém',
        AddWarehouse: 'Adicionar Armazém',
        WarehouseQty: 'Quantidade no Armazém',
        Warehouse: 'Armazém',
        Warehouses: 'Armazéns',
        Variants: 'Variantes',
        VariantName: 'Nome da Variante',
        productVariant: 'Variantes do Produto',
        AddVariant: 'Adicionar Variantes',
        TranferItem: 'Transferir Itens',
        AddUnit: 'Nova Unidade',
        InitialStkWarehouse: 'Estoque inicial necessário para adicionar variantes',
        InitialStockinwarehouse: 'Estoque inicial no armazém',
        TotalQuantity: 'Quantidade Total:',
        AddNote: 'Adicionar Nota (Preço de custo)',
        AddNotetitle: 'Adicionar Nota',
        VariantSuccessMessage: 'Variante do produto atualizada com sucesso',
        Next: 'Próximo',
        Submit: 'Enviar',
        INACTIVE: 'INATIVO',
        errorone: 'Ops! A quantidade solicitada para',
        errortwo: 'não corresponde às quantidades alocadas nos armazéns. Ajuste a quantidade ou reabasteça.',
        SelectWarehouse: 'Selecionar Armazém',
        SelectVariant: 'Selecionar Variante',
        Discount: 'Desconto',
        DiscountDetails: 'Detalhes do Desconto',
        FinalPrice: 'Preço Final',
        DiscountType: 'Tipo de Desconto',
        DiscountPer: 'Desconto %',
        DiscountValue: 'Valor do Desconto',
        Discountonprice: 'Desconto no preço',
        Discountondiscount: 'Desconto sobre desconto',
        AdditionalDiscount: 'Desconto Adicional',
        SellingPrice: 'Preço de Venda:',
        Save: 'Salvar',
        OnOriginalPrice: 'No Preço Original',
        OnDiscountedPrice: 'No Preço com Desconto',
        columnSelector: {
            title: 'Mostrar colunas',
            columnsButton: 'Colunas',
            costPrice: 'Preço de custo',
            sellingPrice: 'Preço de venda',
            sku: 'SKU',
            warehouse: 'Armazém',
            categories: 'Categorias',
            safetyStock: 'Estoque de segurança',
            attributes: 'Atributos',
            notes: 'Notas',
            description: 'Descrição',
            more: 'mais',
            attribute: 'Atributo',
            attributesTitle: 'Atributos',
            categoriesTitle: 'Categorias',
            skuAliases: 'Aliases de SKU'
        }
    },
    note: {
        title: 'Notas',
        add: 'Adicionar Nota',
        no_note: 'Nenhuma nota disponível'
    },

    settings: {
        category: 'Categoria',
        language: 'Idioma',
        switch_business: 'Trocar Negócio',
        currencySelect: 'Moeda',
        languageChangeSuccess: 'Moeda Atualizada com Sucesso',
        languageChangeErrorMessage: 'Algo Deu Errado ao Atualizar a Moeda',
        currencyAdded: "Moeda adicionada com sucesso",
        currencyDelete: "Moeda excluída com sucesso",
        Selectyourpreferredlanguage: "Selecione seu idioma preferido",
    },

    selectProductStock: 'Selecionar Produto',

    category: {
        category_list: {
            title: 'Categorias de Produtos'
        },
        add_category: {
            button: 'Nova Categoria',
            title: 'Adicionar Nova Categoria'
        },
        edit_category: {
            title: 'Editar Categoria'
        },
        name: 'Nome da Categoria',
        name_placeholder: 'Digite o Nome da Categoria',
        no_category: 'Nenhuma categoria disponível'
    },

    staff: {
        add: 'Adicionar Funcionário',
        edit: 'Editar Funcionário',
        access: {
            stock: 'Estoque',
            add_product: 'Adicionar novo produto',
            edit_product: 'Editar produto',
            delete_product: 'Excluir produto',
            view_capital_price: 'Visualizar preço de custo',
            add_category: 'Adicionar nova categoria',
            edit_category: 'Editar categoria',
            delete_category: 'Excluir categoria',
            add_supplier: 'Adicionar novo fornecedor',
            edit_supplier: 'Editar fornecedor',
            delete_supplier: 'Excluir fornecedor',
            add_customer: 'Adicionar novo cliente',
            edit_customer: 'Editar cliente',
            delete_customer: 'Excluir cliente',
            add_staff: 'Adicionar funcionário',
            edit_staff: 'Editar funcionário',
            delete_staff: 'Excluir funcionário',
            change_business_profile: 'Alterar perfil do negócio',
            access_by_product_category: 'Acesso por Categoria de Produto',
            no_category_message: 'Você não adicionou nenhuma categoria. Por favor, adicione uma lista de categorias.',
            expenses: 'Despesas',
            view_expenses: 'Ver despesas',
            add_expenses: 'Adicionar despesas',
            edit_expenses: 'Editar despesas',
            delete_expenses: 'Excluir despesas',
            warehouse: 'Armazém',
            add_new_warehouse: 'Adicionar novo armazém',
            edit_warehouse: 'Editar armazém',
            delete_warehouse: 'Excluir armazém',
            transfer_warehouse: 'Transferência de Armazém',
            transfer_warehouse_approval: 'Aprovação de Transferência de Armazém',
            access_by_warehouse: 'Acesso por Armazém',
            no_warehouse_message: 'Você não adicionou nenhum armazém. Por favor, adicione uma lista de armazéns.',
            purchase_order: "Ordem de compra",
            purchase_order_creation: "Criação de ordem de compra",
            purchase_order_edit: "Edição de ordem de compra",
            purchase_order_cancel: "Cancelar ordem de compra",
            purchase_order_reopen: "Reabrir ordem de compra",
            purchase_order_receive: "Recebimento de ordem de compra",
            sales_order: "Ordem de venda",
            sales_order_creation: "Criação de ordem de venda",
            sales_order_edit: "Edição de ordem de venda",
            sales_order_cancel: "Cancelar ordem de venda",
            sales_order_reopen: "Reabrir ordem de venda",
            sales_order_receive: "Ordem de venda enviada",
            purchase_order_approval: "Aprovação de ordem de compra",
            sales_order_approval: "Aprovação de ordem de venda",
            can_do_available_warehouse: "Armazém disponível",
            add_batch: "Aprovação de criação de lote"
            ,
            notification: 'Notificação',
            staffNotification: 'Ativar notificação',
            assignee: "Atribuído",
        },
        no_staff: 'Nenhum funcionário disponível.'
    },

    code: {
        title: 'Novo Funcionário Adicionado!',
        subtitle: 'Compartilhe o código de convite abaixo para participar:',
        valid: 'Código válido por apenas 48 horas',
        share: 'Compartilhar no WhatsApp',
        copied: 'Copiado!',
        invalid: 'Código inválido!'
    },

    history: {
        no_history: 'Nenhum histórico.',
        detail: {
            remove: 'Remover Histórico',
            confirm: 'Esta funcionalidade afetará o estoque existente, o histórico e os relatórios.'
        },
        no_history_selected: "Nenhum histórico selecionado",
        select_history_hint: "Clique em um histórico da lista para ver os detalhes",
        select_from_left: "Selecione no painel esquerdo",
    },

    supplier: {
        add: {
            title: 'Adicionar Fornecedor'
        },
        edit: {
            title: 'Editar Fornecedor'
        },
        new: 'Novo fornecedor',
        no_supplier: 'Nenhum fornecedor disponível.',
        bank: {
            title: 'Detalhes Bancários'
        },
        note: 'Notas',
        form: {
            name: {
                label: 'Nome do Fornecedor',
                placeholder: 'Digite o Nome do Fornecedor',
                placheolder_not_mandatory: 'Digite o nome',
                error: {
                    required: 'O nome não pode estar vazio'
                }
            },
            contact: {
                label: 'Número de Contato',
                placeholder: '91934554432',
                error: {
                    required: 'O número de contato não pode estar vazio',
                    invalid: 'Número inválido. Deve incluir o código do país'
                }
            },
            bank_name: {
                label: 'Nome do Banco',
                placeholder: 'Digite o Nome do Banco'
            },
            bank_account_name: {
                label: 'Nome do Titular da Conta',
                placeholder: 'Digite o Nome do Titular da Conta'
            },
            bank_account_number: {
                label: 'Número da Conta',
                placeholder: 'Digite o Número da Conta'
            },
            note: {
                label: 'Notas',
                placeholder: 'Adicionar Notas'
            },
            openingBalance: {
                addBtn: 'Adicionar saldo inicial',
                label: 'Saldo inicial',
                placeholder: 'Inserir saldo inicial',
                error: {
                    negative: 'O saldo inicial não pode ser negativo'
                }
            }
        },
        choose: 'Escolher Fornecedor'
    },

    customer: {
        add: {
            title: 'Adicionar Cliente'
        },
        edit: {
            title: 'Editar Cliente'
        },
        new: 'Novo cliente',
        no_customer: 'Nenhum cliente disponível.',
        note: 'Notas',
        form: {
            name: {
                label: 'Nome do Cliente',
                placeholder: 'Digite o Nome do Cliente',
                placheolder_not_mandatory: 'Digite o nome',
                error: {
                    required: 'O nome não pode estar vazio'
                }
            },
            contact: {
                label: 'Número de Contato',
                placeholder: '91934554432',
                error: {
                    required: 'O número de contato não pode estar vazio',
                    invalid: 'Número inválido. Deve incluir o código do país'
                }
            },
            address: {
                label: 'Endereço',
                placeholder: 'Digite o Endereço'
            },
            note: {
                label: 'Notas',
                placeholder: 'Adicionar Notas'
            },
            openingBalance: {
                addBtn: 'Adicionar saldo inicial',
                label: 'Saldo inicial',
                placeholder: 'Inserir saldo inicial',
                error: {
                    negative: 'O saldo inicial não pode ser negativo'
                }
            }
        },
        choose: "Selecionar cliente",
        report: {
            view: 'Visualizar Relatório do Comprador',
            title: 'Relatório do Cliente',
            no_report: 'Não há relatórios para compradores na data selecionada.',
            column: {
                name: 'Nome',
                total_transaction: 'Total de Transações',
                total_amount: 'Total de Vendas',
                total_profit: 'Lucro Total'
            }
        }
    },

    confirm_delete: 'Tem certeza de que deseja excluir esses dados?',

    report: {
        title: 'Relatório'
    },

    accounting: {
        download_pdf_report: 'Baixar PDF',
        title: 'Contabilidade',
        view_report: 'Visualizar Relatório Financeiro',
        dashboard_title: 'Relatório Financeiro',
        stats: 'Estatísticas',
        accounting_report: 'Relatório de Contabilidade',
        filter: {
            date: {
                placeholder: 'Selecionar Data',
                submit: 'Aplicar',
                cancel: 'Redefinir Filtro'
            },
            timeframe: {
                day: 'Diário',
                week: 'Semanal',
                month: 'Mensal',
                year: 'Anual'
            }
        },
        total_sales: 'Total de Vendas',
        total_purchases: 'Total de Compras',
        total_profit: 'Lucro Total',
        total_expenses: 'Despesas Totais',
        assets_value: 'Valor Atual dos Ativos',
        total_current_cogs_value: 'Valor Total Atual do COGS',
        current_asset_selling_price: 'Preço de Venda do Ativo Atual',
        total_selling_price: 'Preço Total de Venda',
        table: {
            date: 'Data',
            sales: 'Vendas',
            purchases: 'Compras',
            profit: 'Lucro',
            expenses: 'Despesas'
        },
        no_data: 'Nenhum dado disponível.'
    },

    stock_report: {
        title: 'Relatório de Estoque',
        view: 'Visualizar Relatório de Estoque',
        no_report: 'Nenhum registro de estoque para a data ou funcionário selecionado.',
        allStaffPlaceHolder: 'Todos os Funcionários',
        column: {
            total_product: 'Tipos de Produtos Atuais',
            total_product_quantity: 'Total de Produtos Atuais'
        }
    },

    subscription: {
        paywall_small: {
            title: 'Recurso VIP',
            description:
                'Seu período de teste para este recurso terminou. Apoie o desenvolvimento deste aplicativo local assinando.',
            button: 'Ver Planos de Assinatura'
        }
    },

    payment: {
        order: {
            title: 'Pagamento'
        }
    },

    imageUploadMessage: {
        uploadSize: 'O tamanho da imagem não deve exceder 5MB!',
        failedMessage: 'Falha ao carregar a imagem do item, por favor, tente novamente!',
        successUpload: 'A imagem foi carregada com sucesso!',
        failedUIError: 'Falha ao excluir a imagem, por favor, tente novamente!',
        SuccessErrorImage: 'A imagem foi excluída com sucesso!'
    },

    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Nome do Produto',
        categoryLabel: 'Categoria',
        BuyingPriceLabel: 'Preço de Compra',
        SellingLabel: 'Preço de Venda',
        StockLabel: 'Estoque'
    },

    historyColumns: {
        Transactionlabel: 'Tipo de Transação',
        Locallabel: 'Horário Local',
        Createdlabel: 'Criado Por',
        Vendorlabel: 'Nome do Fornecedor',
        Buyerlabel: 'Nome do Comprador',
        SKUlabel: 'SKU',
        Invoicelabel: 'Fatura',
        Productlabel: 'Nome do Produto',
        Categorylabel: 'Categoria',
        Buyinglabel: 'Preço de Compra',
        Sellinglabel: 'Preço de Venda',
        Initiallabel: 'Estoque Inicial',
        Finallabel: 'Estoque Final',
        Stocklabel: 'Alteração de Estoque'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Nome do Produto',
        categoryLabel: 'Categoria',
        buyingPriceLabel: 'Preço de Compra',
        sellingPriceLabel: 'Preço de Venda',
        stockInLabel: 'Entrada de Estoque',
        stockOutLabel: 'Saída de Estoque',
        remainingStockLabel: 'Estoque Restante',
        openStockLabel: 'Estoque Inicial',
        weightedAverageCost: 'Custo Médio Ponderado',
        weightedAverageCostLabel: 'Custo Médio Ponderado',
        weightedAverageValueLabel: 'Valor Médio Ponderado'
    },
    accountingReportColumns: {
        dateRange: 'Intervalo de datas',
        reportingPeriod: 'Período de relatório',
        reportGenerate: 'Gerar relatório',
        warehouse: 'Armazém',
        labelDate: 'Data',
        labelSales: 'Vendas',
        labelPurchases: 'Compras',
        labelProfit: 'Lucro',
        labelExpenses: 'Despesas',
        reportOptions: 'Colunas do relatório',
        summaryCards: 'Cartões de resumo',
        grandTotal: 'Total Geral',
        continued: 'cont.',
        subtotal: 'Subtotal',
        page: 'Página'
    },
    customerReportColumns: {
        labelName: 'Nome',
        labelTotalTransaction: 'Total de Transações',
        labelTotalSales: 'Total de Vendas',
        labelTotalProfit: 'Lucro Total'
    },

    scannerDialog: {
        finished: 'Concluído',
        reduce: 'Reduzir',
        successfull: 'Bem-sucedido',
        searching: 'Pesquisando...',
        title: 'Scanner ativo. Aponte para o código de barras!'
    },
    historyFilter: {
        SelectBuyer: 'Selecionar Comprador',
        SelectVendor: 'Selecionar Fornecedor'
    },
    productStockFilter: {
        StockLowtoHigh: 'Estoque Baixo para Alto',
        StockHightoLow: 'Estoque Alto para Baixo',
        AlphabetAZ: 'Alfabeto A-Z',
        AlphabetZA: 'Alfabeto Z-A'
    },
    minimizeTitle: 'Scanner ativo',
    security_guarantee: {
        title: 'Segurança de Dados Garantida'
    },
    invoice: {
        invoicePlaceholder: 'Número da Fatura',
        invoiceTitle: 'Fatura',
        manageInvoiceAddress: 'Gerenciar endereço de fatura',
        selectOrManageAddresses: 'Selecione, edite ou crie endereços de fatura personalizados',
        useBusinessProfileAddress: 'Usar endereço do perfil comercial',
        noCustomAddressesFound: 'Nenhum endereço personalizado adicionado',
        createCustomAddressDesc: 'Adicione endereços de cobrança ou de filiais personalizados para imprimir em suas faturas em vez dos dados padrão do perfil comercial.',
        defaultFromBusinessProfile: 'Padrão do perfil comercial',
        editInvoiceAddress: 'Editar endereço de fatura',
        createNewInvoiceAddress: 'Criar novo endereço de fatura',
        logoHeaderImage: 'Logo / Imagem de cabeçalho',
        deleteInvoiceAddress: 'Excluir endereço de fatura?',
        deleteAddressConfirmText: 'Tem certeza de que deseja excluir este endereço de fatura? Esta ação não pode ser desfeita.'
    },
    ManageInvoiceAddress: 'Gerenciar endereço de fatura',
    SelectOrManageAddresses: 'Selecione, edite ou crie endereços de fatura personalizados',
    UseBusinessProfileAddress: 'Usar endereço do perfil comercial',
    CreateNewAddress: 'Criar novo endereço',
    UpdatingList: 'Atualizando lista...',
    NoCustomAddressesFound: 'Nenhum endereço personalizado adicionado',
    CreateCustomAddressDesc: 'Adicione endereços de cobrança ou de filiais personalizados para imprimir em suas faturas em vez dos dados padrão do perfil comercial.',
    DefaultFromBusinessProfile: 'Padrão do perfil comercial',
    EditInvoiceAddress: 'Editar endereço de fatura',
    CreateNewInvoiceAddress: 'Criar novo endereço de fatura',
    LogoHeaderImage: 'Logo / Imagem de cabeçalho',
    UploadingImage: 'Enviando imagem...',
    UploadImage: 'Enviar imagem',
    BusinessName: 'Nome do negócio',
    AddressDetails: 'Detalhes do endereço',
    PhoneNumber: 'Número de telefone',
    EmailAddress: 'Endereço de e-mail',
    DeleteInvoiceAddress: 'Excluir endereço de fatura?',
    DeleteAddressConfirmText: 'Tem certeza de que deseja excluir este endereço de fatura? Esta ação não pode ser desfeita.',

    stocklowreport: {
        no_stocklowreport_one: 'Nenhum item com configurações de Estoque de Segurança.',
        no_stocklowreport_two: 'Por favor, adicione a quantidade de Estoque de Segurança.',
        currentStock: 'Estoque atual',
        safetyStock: 'Estoque de segurança',
        pricing: 'Preços',
        costPrice: 'Preço de custo',
        sellingPrice: 'Preço de venda',
        productInfo: 'Informações do produto',
        category: 'Categoria',
        description: 'Descrição',
        no_description: 'Nenhuma descrição adicionada',
        variants: 'Variantes',
        unitsOnHand: 'unidades disponíveis',
        minimumThreshold: 'limite mínimo',
        adjust: 'Ajustar',
        all: 'Todos',
        lowStock: 'Estoque baixo',
        variantsDetails: 'Detalhes das variantes',
        qty: 'Qtd.',
        addSafetyStock: 'Adicionar estoque de segurança',
        searchByNameSku: 'Pesquisar por nome/SKU',
        safetyStockShort: 'S',
        warehouseSafetyStock: 'Estoque de segurança do armazém'
    },

    low_alert_stock: 'Inserir quantidade de estoque de segurança',
    lowStockAlertNotify: 'Você receberá uma notificação quando o estoque cair abaixo da quantidade definida',
    applyButtonStockAlert: 'Aplicar',
    cancelButtonStockAlert: 'Cancelar',
    searchProductLabel: 'Pesquisar produtos...',
    successfullyAddedSafetyStock: 'Estoque de Segurança atualizado com sucesso',
    safety_Stock: 'Estoque de Segurança',
    safety_stock_placeholder: 'Digite o Estoque de Segurança',
    lowStockDetailsInfo: {
        ProductCode: 'Código do Produto',
        SafetyStock: 'Estoque de Segurança',
        Stock: 'Estoque',
        CostPrice: 'Preço de Custo',
        SellingPrice: 'Preço de Venda',
        Category: 'Categoria',
        Description: 'Descrição',
        ExpirationDate: 'Data de Validade'
    },
    CustomLang: {
        Attribute: 'Atributo',
        AddAttribute: 'Adicionar Atributo',
        EditAttribute: 'Editar Atributo',
        CustomLabePlaceholder: 'Digite o Nome do Atributo',
        CustomLabePlaceholderSelect: 'Selecionar Tipo',
        AddMoreAttribute: 'Adicionar Mais Atributos',
        ItemAttribute: 'Atributo do Item',
        TableName: 'Nome',
        TableType: 'Tipo',
        TableAction: 'Ação',
        TableDelete: 'Excluir',
        TableEdit: 'Editar',
        deleteMessage: 'Atributo Excluído com Sucesso',
        editSuccessMessage: 'Atributo Atualizado com Sucesso',
        AddSuccessMessage: 'Atributo Adicionado com Sucesso',
        AddAtt: 'Adicionar',
        EditAtt: 'Editar',
        SubmitAtt: 'Enviando...'
    },
    Expenses: {
        ExpensesTitle: 'Despesas',
        AddExpenses: 'Adicionar Despesas',
        ExpenseCategory: 'Categoria de Despesa',
        NoExpenseCategory: 'Nenhuma categoria de despesa',
        AddExpenseCategory: 'Adicionar categoria de despesa',
        SelectExpenseCategory: 'Selecionar categoria de despesa',
        NoExpenses: 'Nenhuma Despesa',
        ExpensesSuccess: 'Despesas criadas com sucesso',
        ExpensesSuccessEdit: 'Despesas atualizadas com sucesso',
        ExpensesCategoryName: 'Nome da categoria de despesa',
        ExpensesSuccessDelete: 'Despesas excluídas com sucesso',
        AddNEC: "Adicionar nova categoria de despesas",
        NC: "Nova categoria de despesas",
        EditNEC: "Editar categoria de despesas"
    },

    Manufacturing: {
        ProducedProduct: "Produto fabricado",
        QuantityManufactured: "Quantidade fabricada",
        UnitCost: "Custo unitário",
        RawMaterialsTotal: "Total de matérias-primas",
        TotalManufacturingCost: "Custo total de fabricação",
        NoRawMaterialsConsumed: "Nenhuma matéria-prima consumida.",
        CostBreakdown: "Detalhamento de custos",
        GeneratedBatch: "Lote gerado",
        StoredBinLocation: "Local de armazenamento",
        NoManufacturingTransactionsFound: "Nenhuma transação de fabricação encontrada",
        AddManufacture: 'Adicionar Detalhes de Fabricação',
        Manufacturing: 'Fabricação',
        RawMaterials: 'Matérias-Primas',
        AdditonCosts: 'Custos Adicionais',
        RawMaterial: 'Matéria-Prima',
        AdditonCost: 'Custo Adicional',
        TotalCost: 'Custo Total',
        AddRawMaterial: 'Adicionar matéria-prima para',
        AddAdditonCost: 'Adicionar custo adicional para',
        AddMore: 'Adicionar mais',
        Add: 'Adicionar',
        Update: 'Atualizar',
        Updating: 'Enviando...',
        ProductRequired: 'Produto é obrigatório',
        QuantityRequired: 'Quantidade é obrigatória',
        ChargeRequired: 'Custo é obrigatório',
        EstimatedCostRequired: 'Custo Estimado é obrigatório',
        PurchasePriceRequired: 'Preço de Compra é obrigatório',
        SelectCharge: 'Selecionar Custo',
        EstimatedCost: 'Custo Estimado',
        SelectProduct: 'Selecionar um Produto',
        Quantity: 'Quantidade',
        ManufactureDetails: 'Detalhes de Fabricação',
        BuyingPrice: 'Preço de Compra',
        LabourCharge: 'Custo de Mão de Obra',
        ElectricityCost: 'Custo de Eletricidade',
        PackagingCharge: 'Custo de Embalagem',
        LogisticCost: 'Custo de Logística',
        OtherCharges: 'Outros Custos',
        Save: 'Salvar detalhes',
        PurchasePrice: 'Preço de Compra',
        Date: 'Data',
        For: 'Para',
        PurchaseRate: 'Taxa de Compra (Preço)',
        Scrolltoloadmore: 'Role para carregar mais...',
        Noproductsfound: 'Nenhum produto encontrado',
        ManufacturingQuantity: 'Quantidade de Fabricação',
        ManufactureAddedSuccess: 'Detalhes de Fabricação atualizados com sucesso'
    },

    Warehouses: {
        transferOrder: 'Transferir Itens',
        AddTransferOrder: 'Adicionar Transferência de Itens',
        NewWarehouse: 'Novo Armazlinebreakazém',
        newHead: 'Comece a gerenciar múltiplos armazéns!',
        headTwo: 'Acompanhe e gerencie seu inventário de forma integrada em vários armazéns',
        EnableWarehouse: 'HABILITAR ARMAZÉM',
        EnableWarehouse2: 'Habilitar Armazém',
        OrganizationPrimary: 'Primário da Organização',
        Edit: 'Editar',
        AreEnableWarehouse: 'Tem certeza de que deseja habilitar o armazém?',
        Confirm: 'Confirmar',
        Cancel: 'Cancelar',
        WarehouseCreatedSuccessfully: 'Armazém criado com sucesso',
        MarkAsOP: 'Marcar como Primário da Organização',
        MarkAsInAct: 'Marcar como Inativo',
        MarkAsAct: 'Marcar como Ativo',
        MarkedAsInactive: 'Armazém marcado como inativo com sucesso',
        MarkedAsActive: 'Armazém marcado como ativo com sucesso',
        MarkedAsOP: 'Armazém marcado como ativo com sucesso',
        EditWarehouse: 'Editar Armazém',
        AddWarehouse: 'Adicionar Armazém',
        WarehouseNameIsRequired: 'Nome do Armazém é obrigatório',
        EnterWarehouseName: 'Digite o nome do armazém',
        EnterEmail: 'Digite o e-mail',
        EnterPhoneNumber: 'Digite o número de telefone',
        Location: 'Localização...',
        name: 'Nome do armazém',
        email: 'E-mail',
        phoneNumber: 'Número de telefone',
        location: 'Localização',
        noWarehouse: "Nenhum armazém corresponde à sua pesquisa"
    },

    Assets: {
        headerTitle: 'Ativos',
        addAssetMessage:
            'Adicione ativos aqui. Para atribuir um ativo a um funcionário, vá para o perfil do funcionário.',
        addAsset: 'Adicionar Ativo',
        editAsset: 'Editar Ativo',
        assetCode: 'Código do Ativo',
        assetName: 'Nome do Ativo',
        assetCategory: 'Categoria do Ativo',
        assetType: 'Tipo de Ativo',
        serialNumber: 'Número de Série',
        location: 'Localização',
        condition: 'Condição',
        selectCondition: 'Selecionar Condição',
        fair: 'Razoável',
        good: 'Bom',
        excellent: 'Excelente',
        poor: 'Ruim',
        notes: 'Notas',
        submit: 'Enviar',
        submitting: 'Enviando',
        noCategory: 'Nenhuma categoria',
        selectCategory: 'Selecionar categoria',
        addAssetCat: 'Adicionar Categoria de Ativo',
        addAssetCatName: 'Nome da categoria de ativo',
        edit: 'Editar',
        status: 'Status',
        createdAt: 'Criado Em',
        viewAsset: 'Visualizar Ativo',
        assignAsset: 'Atribuir Ativo',
        conditionRet: 'Condição (Na devolução)',
        searchSelectAssets: 'Pesquisar/Selecionar Ativo',
        assetAssigned: 'Ativo atribuído com sucesso',
        assetReturned: 'Ativo devolvido com sucesso',
        selectAnAsset: 'Por favor, selecione um ativo',
        action: 'Ação',
        noAssetAssigned: 'Nenhum ativo atribuído',
        reAssigned: 'Reatribuir',
        assignedAssetsList: 'Lista de Ativos Atribuídos',
        viewHistory: "Ver histórico",
        history: "Histórico de ativos",
        loadingHistory: "Carregando histórico...",
        loadingMore: "Carregando mais...",
        dateTime: "Data e hora",
        staff: "Funcionário",
        AssignedBy: "Atribuído por",
        assign: "ATRIBUIR",
        return: "DEVOLVER",
        unknown: "DESCONHECIDO",
        noHistory: "Nenhum histórico disponível para este ativo.",
        enterReturnNote: "Insira uma nota para devolução",
        returnNote: "Nota de devolução",
        enterAssignNote: "Insira uma nota para atribuição",
        assignNote: "Nota de atribuição",
        AddNAC: "Adicionar nova categoria de ativos",
        EditNAC: "Editar categoria de ativos",
        others: "Outros"
    },
    LedgerTransaction: {
        ledgerDetails: 'Detalhes do Livro-razão',
        productName: 'Nome do Produto',
        totalQty: 'Quantidade Total',
        date: 'Data',
        receivedAmt: 'Valor Recebido',
        paid: 'Pago',
        discount: 'Desconto',
        balance: 'Saldo',
        more: 'mais',
        total: 'Total',
        ledgerupdatedsuccessfully: 'Livro-razão atualizado com sucesso',
        ledgeraddedsuccessfully: 'Livro-razão adicionado com sucesso',
        viewLedger: 'Visualizar Livro-razão',
        edit: 'Editar',
        create: 'Criar',
        Recieved: 'Recebido [entrada de estoque]',
        payMode: 'Modo de Pagamento',
        Refno: 'Nº de Referência'
    },
    ExtraField: {
        attachment: 'Anexo',
        acceptOnlyImg: 'Aceita apenas imagens.',
        addAttribute: 'Adicionar Atributo',
        acceptImgAndDoc: "Aceitar Imagens e Documentos",
    },
    phoneInvoiceDownload: {
        Variant: 'Variante',
        Warehouse: 'Armazém',
        Bin: 'Bin',
        Batch: 'Lote',
        Attributes: 'Atributos'
    },
    ImportExcel: {
        ImportStockfromExcel: "Importar Estoque do Excel",
        DragDrop: "Arraste e solte seu arquivo Excel preenchido aqui ou clique para navegar",
        DT: "Baixar Modelo",
        GB: "Voltar",
        Downloading: "Baixando...",
        ChangeFile: "Alterar Arquivo",
        ReadingExcelfile: "Lendo arquivo Excel...",
        Processing: "Processando...",
        submitUpdateStock: "Enviar & Atualizar Estoque",
        downloadLatestTemplate: "Baixar Modelo Mais Recente",
        loginRequired: "Login Necessário"
    },
    stockForm: {
        recordPaymentNow: "Registrar pagamento agora",
        recordPaymentDescCustomer: "Insira o valor pago pelo cliente",
        recordPaymentDescSupplier: "Insira o valor pago pelo fornecedor",
        managePayments: "Gerenciar pagamentos",
        invoice: "Fatura",
        challan: "Guia",
        recordPayment: "Registrar pagamento",
        payableAmount: "Valor a pagar",
        paidAmount: "Valor pago",
        paymentMethod: "Método de pagamento",
        paymentDate: "Data de pagamento",
        reference: "Referência",
        billId: "Número da fatura",
        importExcel: "Importar do Excel",
        noThanks: "Não, obrigado",
        checkHistory: "Ver histórico",
        wantViewHistory: "Deseja ver o histórico?",
        enterPayable: "Digite o valor a pagar",
        enterPaid: "Digite o valor pago",
        selectPayment: "Selecionar método de pagamento",
        attachment: "Anexo",
        note: "Nota"
    },
    HistoryEdit: {
        products: "Produtos",
        add_product: "Adicionar produto",
        paidAmountInvalidMessage: "O valor pago não pode ser maior que o valor a pagar",
        removingText: "Remover este produto irá reverter as alterações de estoque feitas durante esta transação.",
        remove: "Remover"
    },
    ExcelProduct: {
        uploadFile: "Enviar arquivo",
        dragDrop: "Arraste e solte seu arquivo Excel ou clique para enviar.",
        parsingFile: "Analisando arquivo",
        fileSelected: "Arquivo selecionado",
        reviewImportedData: "Revise os dados importados abaixo. As colunas são correspondidas automaticamente quando possível.",
        changeFile: "Alterar arquivo",
        back: "Voltar",
        invalidFileType: "Envie um arquivo Excel válido (.xlsx ou .xls)",
        parseExcelError: "Erro de análise do Excel:",
        noData: "O arquivo Excel enviado não contém dados.",
        failedToRead: "Falha ao ler o arquivo Excel. Tente novamente.",
        Nodata: "SEM_DADOS",
        unableToRead: "Não foi possível ler o arquivo.",
        buyingMustNumber: "O preço de compra deve ser um número",
        sellingMustNumber: "O preço de venda deve ser um número",
        mustBeNumber: "deve ser um número",
        bulkUploadfailed: "Falha no envio em massa",
        importFromExcel: "Importar do Excel",
        generating: "Gerando...",
        downloadTemplate: "Baixar modelo",
        uploading: "Enviando...",
        done: "Concluído",
        requiredField: "{field} é obrigatório",
        bulkUpload: "Envio em massa",
        duplicateSku: "SKU duplicado encontrado",
        uploadedSuccessfully: "Todos os produtos foram carregados com sucesso!",
        uploadCompleteIssues: "Upload concluído com problemas",
        uploaded_products: "{count} produto(s) carregado(s).",
        failed_products: "{count} falharam.",
        failed_items: "Itens com falha:"
    },
    Discount: {
        overallDiscount: "Desconto total",
        final: "Total final",
        balanceDue: "Saldo devedor",
        tax: "Imposto"
    },
    ProductForm: {
        barcodeQuantity: "Insira a quantidade do código de barras",
        baseUnit: "Unidade base (primária)",
        addSecondaryUnit: "Adicionar unidade secundária?",
        selectUnit: "Selecionar unidade",
        subUnitDetails: "Detalhes da subunidade",
        subUnit: "Subunidade",
        selectSubUnit: "Selecionar subunidade",
        conversionRate: "Taxa de conversão",
        exampleLogic: "Lógica do exemplo:",
        example: "Se você vende canetas em caixas, defina a unidade base como Caixa e adicione uma subunidade (peça) com conversão de 50. Isso significa que 1 caixa contém 50 peças.",
        basePrice: "Preço base"
    },
    barcode: {
        settings: 'Configurações de Código de Barras',
        labelSize: 'Tamanho da etiqueta',
        customSize: 'Tamanho personalizado...',
        widthMm: 'Largura (mm)',
        heightMm: 'Altura (mm)',
        showPrice: 'Mostrar preço de venda na etiqueta',
        noPrices: 'Nenhum preço de venda configurado para este produto.',
        preview: 'Visualização',
        generate: 'Gerar',
        label: 'etiqueta',
        singlePage: 'Página Única',
        downloadOptions: 'Opções de Download',
        chooseLayout: 'Escolha o layout para os códigos de barras',
        allInSinglePage: 'Adicionar todos os códigos de barras em uma única página.',
        allInA4Grid: 'Tudo em Página Única',
        allInA4GridSub: 'Organiza todos os códigos de barras em uma grade A4',
        onePerPage: 'Um Por Página',
        onePerPageSub: 'Cada código de barras em sua própria página de etiqueta'
    },

    TransferItem: {
        transferItem: "Transferência de itens",
        Date: "Data",
        Reason: "Motivo",
        enterReason: "Digite o motivo",
        Name: "Nome",
        QuantityTransfered: "Quantidade transferida",
        SWarehouse: "Armazém de origem",
        SelectSWarehouse: "Selecionar armazém de origem",
        DWarehouse: "Armazém de destino",
        SelectDWarehouse: "Selecionar armazém de destino",
        CreatedBy: "Criado por",
        CreatedTime: "Hora de criação",
        UpdatedTime: "Hora de atualização",
        NoOrderFound: "Nenhum pedido encontrado",
        New: "Novo",
        WarehouseItemTransfer: "Transferência de itens do armazém",
        TotalTransfers: "Total de Transferências",
        EnterReason: "Digite o motivo",
        ItemDetails: "Detalhes do item",
        CurrentAvailable: "Disponibilidade atual",
        TransferQty: "Quantidade de transferência",
        SStock: "Estoque de origem",
        DStock: "Estoque de destino",
        addDescription: "Adicionar descrição do item",
        selectVariant: "Selecionar variante",
        addNewRow: "Adicionar nova linha",
        typeOrSelectItem: "Digite para pesquisar",
        scrollToLoadMore: "Role para carregar mais",
        noProductsFound: "Nenhum produto encontrado",
        selectWarehouse: "Selecionar armazém"
    },
    Sku: {
        searchSelectProduct: "Pesquisar / selecionar produto",
        searchSelectSku: "Pesquisar / selecionar SKU",
        noSkuFound: "SKU não encontrado"
    },
    HistoryPage: {
        addFilter: "Adicionar filtro",
        filtersActive: "Todos os filtros ativos",
        noProducts: "Nenhum produto",
        download: "Download",
        recentlyUpdated: "Atualizado recentemente",
    },
    StockPage: {
        challanNumber: "Número do challan",
        subTotal: "Subtotal",
        totalTaxes: "Totais e impostos",
        taxInclusive: "Imposto incluído",
        discountedValue: "Valor com desconto",
        taxValue: "Valor do imposto",
        totalAmount: "Valor total",
        close: "Fechar",
        addTax: "Adicionar imposto",
        label: "Rótulo",
        enterLabel: "Inserir rótulo",
        taxRate: "Taxa de imposto",
        enterTaxRate: "Inserir taxa de imposto",
        selectTaxRate: "Selecionar taxa de imposto",
        addNewTax: "Adicionar nova taxa",
        discountProducts: "Valor com desconto (Produtos)",
        taxProducts: "Valor do imposto (Produtos)",
        clickAddPayment: "Clique para adicionar pagamento",
        paidGreaterPayable: "O valor pago não pode ser maior que o valor devido",
        vendorCompulsory: "O fornecedor é obrigatório para registrar o pagamento",
        customerCompulsory: "É necessário um cliente para registrar o pagamento",
        updateInvoiceFormat: "Atualizar formato da fatura",
        updateChallanFormat: "Atualizar formato do challan",
        addPrefix: "Adicionar prefixo",
        prefix: "Prefixo"
    },
    EditHistoryPage: {
        search_by_notes: "Pesquisar por notas",
        alertMessage: "Esta alteração é registrada apenas no histórico e não afeta o estoque atual.",
        paymentDetails: "Detalhes do pagamento",
        units: "Unidades",
        customLabels: "Rótulos personalizados",
        value: "Valor",
        Order_Info: "Informações do Pedido",
        percentage: "Porcentagem",
        Stock_updates_on_submit: "Atualizar estoque ao enviar",
        Summary: "Resumo"
    },
    historyCard: {
        paid: "PAGO",
        partiallyPaid: "PARCIALMENTE PAGO",
        billDate: "Data da fatura",
        productDetails: "Detalhes do produto",
        paymentsHistory: "Histórico de pagamentos",
        updatePayment: "Atualizar pagamento",
        discounts: "Descontos",
        inclusive: "(incl.)",
        discountOverall: "Valor com desconto (Total)",
        dueAmount: "Valor devido",
        enterPaid: "Inserir valor pago",
        enterReference: "Inserir referência",
        enterNote: "Inserir nota",
        enterInvoice: "Inserir fatura",
        enterChallan: "Inserir challan",
        edit: "Editado"
    },
    printInvoice: {
        billTo: "Faturar para",
        ref: "Ref. nº",
        mode: "Modo",
        date: "Data",
        amount: "Valor",
        totalPaid: "Total pago"
    },
    Contact: {
        supplier_required: "Fornecedor é obrigatório para entrada de estoque",
        customer_required: "Cliente é obrigatório para saída de estoque",
        key: "Chave",
        editHistory: "Editar histórico",
        loading: "Carregando..."
    },
    AW: {
        availablewarehouse: "Armazém Disponível",
        visibilityManagement: 'Gestão de Visibilidade',
        availablewarehouses: "Armazéns Disponíveis",
        Active: "Ativo",
        LWarehouse: "Carregando Armazéns...",
        NWForthisProduct: "Nenhum armazém encontrado para este produto.",
        of: "de",
        WarehouseAvailabilty: "Disponibilidade de Armazém",
    },
    Currency: {
        searchCurrency: "Pesquisar moedas...",
        addCurrency: "Adicionar moeda",
        addNewCurrency: "Adicionar nova moeda",
        editCurrency: "Editar moeda",
        currencySymbol: "Símbolo da moeda",
        currencyName: "Nome da moeda",
        enterCurrencySymbol: "Insira o símbolo da moeda",
        enterCurrencyName: "Insira o nome da moeda"
    },
    NewReportLang: {
        DM: "Movimento Diário",
        WR: "Relatório de Armazém",
        PDM: "Movimento Diário do Produto",
        TBP: "Preço Total de Compra",
        TPQ: "Quantidade Total de Produto",
        TP: "Produtos Totais",
        CS: "Estoque Atual",
        IV: "Valor do Inventário",
        DA: "Média Diária",
        TSI: "Total de Entrada de Estoque",
        TSO: "Total de Saída de Estoque",
        TOR: "Taxa de Rotatividade",
        Tv: "Valor Total",
        AST: "Rastreamento Ativo de SKU",
        UT: "Unidades Rastreadas",
        SL: "Nível de Estoque",
        Value: "Valor",
        IO: "ENTRADA/SAÍDA",
        T: "Rotatividade",
        unitsD: "Unidades/Dia",
        Sort: "Ordenar",
        Sort_by: "Ordenar por",
        Units_available: "Unidades disponíveis",
        Units_unavailable: "Unidades indisponíveis",
        Current_assets: "Ativos circulantes",
        Search: "Pesquisar",
        available: "Disponível",
        assigned: "Atribuído",
        AYSWD: "Tem certeza de que deseja excluir?",
        PTS: "Armazém transferido com sucesso",
        AUS: "Ativos atualizados com sucesso",
        ACS: "Ativos criados com sucesso",
        VSP: "Ver preço de venda",
        HUS: "Histórico atualizado com sucesso",
    },
    ReplacementReturn: {
        selectProduct: "Selecione um produto",
        selectReplacementProduct: "Selecione pelo menos um produto de substituição",
        validQuantity: "Insira uma quantidade de devolução válida",
        replacedSuccessfully: "Produto substituído com sucesso",
        returnSuccessfully: "Produto devolvido com sucesso",
        failedProcess: "Falha ao processar. Tente novamente.",
        return: "Devolver",
        replace: "Substituir",
        typeSelectProduct: "Digite ou selecione produto...",
        returnQuantity: "Quantidade de devolução",
        enterQuantity: "Insira quantidade",
        replacementDate: "Data de substituição",
        returnDate: "Data de devolução",
        chooseCustomer: "Escolher cliente",
        additionalNotes: "Adicionar notas adicionais...",
        replacementProducts: "Produtos de substituição",
        addProducts: "Adicionar mais produtos",
        tapSelect: "Toque para selecionar produtos disponíveis",
        currently: "Atualmente",
        item: "item",
        items: "itens",
        selected: "selecionado",
        selectedItems: "Itens selecionados",
        hideDetails: "Ocultar mais detalhes",
        showDetails: "Mostrar mais detalhes",
        product: "produto",
        priceLevel: "Selecionar nível de preço",
        customPrice: "Inserir preço personalizado",
        noReplaceHistory: "Nenhum histórico de substituição encontrado",
        replaceReturn: "Substituir e Devolver",
        replaceReturnHistory: "Histórico de Substituições e Devoluções"
    },
    OtherComponent: {
        mfgHistoryTitle: "Histórico de fabricação",
        mfgHistoryDesc: "Rastrear produtos de estoque fabricados",
        dailyOperation: "Operações Diárias",
        freqUsed: "Ações usadas frequentemente para atualizar registros rapidamente",
        manageCategory: "Gerenciar Categorias",
        organizeCaterory: "Organizar e gerenciar categorias de produtos, despesas e ativos",
        businessRecord: "Registros Empresariais",
        organizeRecord: "Organizar e gerenciar seus registros empresariais",
        trackHistory: "Rastrear Histórico",
        completeTracking: "Histórico completo para auditoria e rastreamento",
        Verifyinventorycount: "Verificar contagem de inventário",
        Exchangerates: "Taxas de câmbio",
        Productiontracking: "Rastreamento de produção",
        Fixedassetregister: "Registro de ativos fixos",
        Storagelocations: "Locais de armazenamento",
        warehouseAvailability: 'Disponibilidade de produtos em nível de armazém',
        Logreviewspend: "Registrar e revisar gastos",
        Productgroupings: "Agrupamentos de produtos",
        Classifyexpenditures: "Classificar despesas",
        Assetclassification: "Classificação de ativos",
        Manageexchanges: "Gerenciar câmbios",
        Returnauditlog: "Log de auditoria de devoluções",
        Interlocationmoves: "Movimentações entre locais",
        Manageoperationscategoriesrecordsandhistory: "Gerenciar operações, categorias, registros e histórico"
    },
    no_permission_dialog: {
        title: 'Sem permissão',
        historyDescription: "Você não tem permissão para visualizar o Histórico de Transações. Entre em contato com o seu administrador.",
        replacementHistoryDescription: "Você não tem permissão para visualizar o Histórico de Substituição e Devolução. Entre em contato com o seu administrador.",
        transferHistoryDescription: "Você não tem permissão para visualizar o Histórico de Transferência de Armazém. Entre em contato com o seu administrador."
    },
    OthersHistory: {
        title: "Gerenciar Histórico",
        transferHistory: "Gerenciar Histórico de Transferências",
        transactionHistory: "Gerenciar Histórico de Transações",
        replacementHistory: "Gerenciar Histórico de Substituições e Devoluções"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Navegue e compre os produtos compartilhados pela empresa.",
        description: "Navegue pelos produtos compartilhados pela empresa.",
        productsAvailable: "Produtos disponíveis",
        noImageAvailable: "Nenhuma imagem disponível",
        productDetails: "Detalhes do produto",
        inStock: "em estoque",
        availableVariants: "Variantes disponíveis",
        options: "opções",
        orders: "Pedidos"
        ,
        searchProducts: "Pesquisar produtos...",
        noProductsFound: "Nenhum produto encontrado",
        tryDifferentKeyword: "Tente pesquisar com outra palavra-chave",
        variants: "Variantes",
        stock: "Estoque",
        cart: "Carrinho",
        products: "Produtos",
        viewCart: "Ver Carrinho",
        backToProducts: "Voltar aos Produtos",
        yourCart: "Seu Carrinho",
        clear: "Limpar",
        cartEmpty: "Seu carrinho está vazio",
        cartEmptyDesc: "Explore o catálogo e adicione os produtos que deseja pedir.",
        browseProducts: "Explorar Produtos",
        selectedItems: "Itens Selecionados",
        itemInCart: "item no carrinho",
        itemsInCart: "itens no carrinho",
        customerDeliveryDetails: "Dados do Cliente e Entrega",
        fullName: "Nome Completo",
        enterFullName: "Insira seu nome completo",
        deliveryAddress: "Endereço de Entrega",
        addressPlaceholder: "Rua, edifício, cidade, CEP...",
        orderNote: "Nota do Pedido (Opcional)",
        orderNotePlaceholder: "Instruções especiais ou notas de entrega...",
        paymentMode: "Forma de Pagamento",
        subtotal: "Subtotal",
        items: "itens",
        totalAmount: "Valor Total",
        orderOnWhatsApp: "Pedir pelo WhatsApp 📲",
        orderPlaced: "Pedido Realizado com Sucesso! 🎉",
        orderPlacedDesc: "Seu pedido foi registrado e o WhatsApp foi aberto.",
        continueShopping: "Continuar Comprando 🛍️",
        cartEmptyTitle: "Carrinho Vazio",
        cartEmptyToast: "Adicione produtos ao carrinho antes de finalizar.",
        incompleteTitle: "Dados Incompletos",
        incompleteToast: "Preencha todos os campos obrigatórios antes de fazer o pedido.",
        nameRequired: "Nome completo é obrigatório",
        addressRequired: "Endereço de entrega é obrigatório",
        catalogUnavailable: "Catálogo Indisponível",
        catalogUnavailableDesc: "Este catálogo não está ativo no momento. Contate o negócio.",
        invalidCatalogLink: "Link do Catálogo Inválido 🚫",
        invalidCatalogDesc: "Esta página do catálogo está faltando informações necessárias.",
        missing: "Ausente",
        catalogSlug: "Slug do Catálogo",
        goBackHome: "Voltar ao Início",
        inventoryManagement: "Gestão de Estoque e Faturamento 🚀 Simply",
        enter: "Inserir",
        select: "Selecionar",
        // Catalog Order translations
        catalogOrders: 'Pedidos do catálogo',
        pending: 'Pendente',
        converted: 'Convertido',
        cancelled: 'Cancelado',
        totalRevenue: 'Valor total',
        totalCatalogOrders: 'Total de pedidos online',
        convertToSalesOrder: 'Converter em pedido de venda',
        date: 'Data',
        status: 'Status',
        action: 'Ação',
        searchOrders: 'Pesquisar cliente ou telefone...',
        noMatchingOrders: 'Nenhum pedido correspondente',
        noStatusOrders: 'Nenhum pedido {status} encontrado',
        tryDifferentSearch: 'Tente pesquisar com um nome de cliente ou número de telefone diferente.',
        noOrdersWithStatus: 'Atualmente não há pedidos com status {status}.',
        noOrdersYet: 'Ainda não há pedidos do catálogo',
        noOrdersDescription: 'Os pedidos feitos no seu catálogo online aparecerão aqui.',
        guestCustomer: 'Cliente convidado',
        item: 'Item',
        moreItems: '+{count} mais',
        viewDetails: 'Ver detalhes',
        viewSalesOrder: 'Ver pedido de venda',
        cancelOrder: 'Cancelar pedido',
        confirmCancelTitle: 'Cancelar pedido do catálogo?',
        confirmCancelOrder: 'Tem certeza de que deseja cancelar este pedido? Esta ação não pode ser desfeita.',
        keepOrder: 'Não, manter pedido',
        confirmCancelAction: 'Sim, cancelar pedido',
        orderNotFound: 'Pedido do catálogo não encontrado',
        orderNotFoundDescription: 'Este pedido não pôde ser encontrado ou você pode não ter permissão para visualizá-lo.',
        backToCatalogOrders: 'Voltar aos pedidos do catálogo',
        placedOn: 'Realizado em',
        totalItems: 'Total de itens',
        orderedProducts: 'Produtos pedidos',
        itemDetails: 'Detalhes do item',
        quantity: 'Qtd.',
        unitPrice: 'Preço unitário',
        total: 'Total',
        variant: 'Variante',
        customerInformation: 'Informações do cliente',
        additionalFields: 'Campos adicionais',
        fields: 'campos',
    },
    stockNew: {
        Npay: "Nenhum produto adicionado ainda",
        emptydesc: "Selecione um produto do seu catálogo e insira a quantidade recebida para registrar o estoque.",
        tipText: "Dica: Você também pode fazer upload de um arquivo excel",
        OT: "Total do Pedido",
        Collapse: "Recolher"
    },
    deleteBulk: {
        Bulkoperation: "Operação em massa",
        Applyproducts: "Aplicar ações a vários produtos",
        Bulkupload: "Upload em massa",
        ImportCSVfile: "Importar produtos via arquivo Excel ou CSV",
        or: "ou",
        Bulkdelete: "Exclusão em massa",
        Permanentlyallproducts: "Remover permanentemente todos os produtos",
        IrrText: "A exclusão em massa é irreversível. Exporte um backup primeiro, se necessário.",
        SeP: "Produtos selecionados",
        sP: "Selecionar produto",
        DA: "Excluir tudo",
        DP: "Excluir produtos",
        sL: "Selecionar tudo",
        ASDE: "Tem certeza que deseja excluir todos os produtos exceto",
        ASDAllP: "Tem certeza que deseja excluir todos os produtos?",
        ASD: "Tem certeza que deseja excluir",
        products: "produtos",
        TACBU: "Esta ação não pode ser desfeita.",
        LP: "Carregando produtos...",
        FM: "Carregando mais...",
        NPF: "Nenhum produto encontrado.",
        LMP: "Carregando mais produtos..."
    },
    NewVariantModal: {
        Definevariantsassign: "Definir variantes e atribuir quantidades",
        Nothingallocated: "Nada atribuído",
        Overallocated: "Sobrealocado",
        Fullyallocated: "Totalmente atribuído",
        Overby: "Excesso de",
        Allvariantsneedaname: "Todas as variantes precisam de um nome.",
        Reducequantities: "Reduzir quantidades.",
        Overallocatedby: "Sobrealocado por",
        Quantitiesmustmatchthetotalavailability: "As quantidades devem corresponder à disponibilidade total.",
        Allocatequantitiesacrosswarehouses: "Atribuir quantidades entre armazéns",
        Notfullydistributed: "Não totalmente distribuído:",
        remaining: "restante",
        Qty: "Qtd",
        Inactive: "Inativo",
        left: "restante"
    },
    ProductFormNew: {
        BasicInfo: "Informações básicas",
        ProductImage: "Imagem do produto",
        Images: "Imagens",
        Pricing: "Preços",
        Everypriceneedsbothalabelandanamount: "Todo preço precisa de um rótulo e um valor",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'Adicione um rótulo como "Atacado" ou "Varejo" para identificar este preço',
        AddMultiplePrice: "Adicionar múltiplos preços",
        NoPhotosLetAiFind: "Sem fotos? Deixe a IA encontrar imagens do produto",
        AddProductImagesTitle: "Adicionar imagens do produto",
        ChooseHowToAddPhotos: "Escolha como deseja adicionar fotos para este produto:",
        SearchWithAi: "Pesquisar com IA",
        SearchWithAiDesc: "Encontre e selecione automaticamente imagens do produto usando IA",
        FilesFileExplorer: "Arquivos (Explorador de arquivos)",
        FilesFileExplorerDesc: "Escolha imagens diretamente do seu computador",
        AiProductImageFinder: "Localizador de imagens com IA",
        AiProductImageFinderDesc: "Pesquise e selecione imagens para seu produto",
        TypeProductNamePlaceholder: "Digite o nome do produto...",
        SearchForYourProduct: "Pesquise seu produto",
        SearchForYourProductHint: `Tente um nome de marca ou produto, ex. "Kirkland Minoxidil"`,
        ImagesSelected: "imagens selecionadas",
        AddSelected: "Adicionar selecionadas"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Definir um novo campo personalizado",
        AttributeName: "Nome do atributo",
        DataType: "Tipo de dado",
        Noattributesfound: "Nenhum atributo encontrado",
        ManageAttributes: "Gerenciar atributos",
        Editordeleteexistingattributes: "Editar ou excluir atributos existentes",
        UpdateAttribute: "Atualizar atributo",
        Saving: "Salvando..."
    },
    NewExpenses: {
        Noexpensesyet: "Ainda sem despesas",
        Addyourfirstexpensetostarttrackingyourspending: "Adicione sua primeira despesa para começar a rastrear seus gastos.",
        TOTALEXPENSES: "DESPESAS TOTAIS",
        ENTRIES: "ENTRADAS",
        BYCATEGORY: "POR CATEGORIA",
        Nocategoriestodisplay: "Nenhuma categoria para exibir",
        DateanfTime: "Data e Hora"
    },
    PurchaseSales: {
        CancelOrder: "Cancelar pedido",
        ReopenOrder: "Reabrir pedido",
        Reopen: "Reabrir",
        ConfirmCancelOrder: "Tem certeza de que deseja cancelar este pedido?",
        ConfirmReopenOrder: "Tem certeza de que deseja reabrir este pedido?",
        OrderCancelledSuccessfully: "Pedido cancelado com sucesso.",
        OrderReopenedSuccessfully: "Pedido reaberto com sucesso.",
        CancelledBy: "Cancelado por",
        Cancelled: "Cancelado",
        ConvertPriceBasedOnUnitConversion: "Converter preço com base na conversão de unidade",
        MarkPaymentAsPending: "Marcar pagamento como pendente",
        PendingReceivableDesc: "Valor registrado como a receber. Registre o pagamento ao recebê-lo.",
        PendingPayableDesc: "Valor registrado como a pagar. Registre o pagamento ao efetuá-lo.",
        SelectCustomerFirst: "Selecione primeiro um cliente",
        SelectSupplierFirst: "Selecione primeiro um fornecedor",
        SelectItemsFirst: "Por favor, selecione pelo menos um item primeiro",
        PaymentMarkedPendingDesc: "O pagamento está marcado como pendente. Desmarque 'Marcar pagamento como pendente' para registrar o pagamento agora.",
        SelectCustomerAndItemFirst: "Por favor, selecione um cliente e pelo menos um item primeiro",
        SelectSupplierAndItemFirst: "Por favor, selecione um fornecedor e pelo menos um item primeiro",
        SelectCustomerProductFirst: "Selecione cliente e produto primeiro",
        SelectSupplierProductFirst: "Selecione fornecedor e produto primeiro",
        Receivables: "Contas a Receber",
        Payables: "Contas a Pagar",
        AccessDenied: "Acesso Negado",
        YouDonthaeP: "Você não tem permissão para visualizar esta página. Se acreditar que isso é um erro, entre em contato com o administrador.",
        purchase: "Compra",
        sales: "Vendas",
        Areyousureyouwantto: "Tem certeza que deseja",
        Thisactionwillupdateitsstatus: "Esta ação atualizará o status.",
        ReasonOPtional: "Motivo (opcional)",
        Enterareasonfor: "Digite um motivo para",
        optionalDot: "(opcional)...",
        Reject: "Rejeitar",
        ConfirmOrder: "Confirmar Pedido",
        RejectOrder: "Rejeitar Pedido",
        Previous: "Anterior",
        First: "Primeiro",
        Order: "Pedido",
        Items: "Itens",
        Memo: "Memo",
        SelectDateRange: "Selecionar Período de Datas",
        List: "Lista",
        Board: "Quadro",
        View: "Visualizar",
        CreateSalesOrder: "Criar Pedido de Venda",
        CreatePurchaseOrder: "Criar Pedido de Compra",
        successfully: "com sucesso",
        ManageAttachments: "Gerenciar Anexos",
        Stockoutitemsimmediatelyaftersaving: "Dar saída no estoque imediatamente após salvar.",
        Stockinitemsimmediatelyaftersavingthisorder: "Dar entrada no estoque imediatamente após salvar este pedido.",
        ViewAttachments: "Visualizar Anexos",
        MemoAttachments: "Memo e Anexos",
        ReceivedDate: "Data de Recebimento",
        ShippedDate: "Data de Envio",
        OrderDate: "Data do Pedido",
        OrderDetails: "Detalhes do Pedido",
        Subtotal: "Subtotal",
        OrderSummary: "Resumo do Pedido",
        AddItem: "Adicionar Item",
        NewSalesOrder: "Novo Pedido de Venda",
        NewPurchaseOrder: "Novo Pedido de Compra",
        Createandmanageyour: "Crie e gerencie seus",
        orders: "pedidos",
        Removeitem: "Remover item",
        UnitPrice: "Preço Unitário",
        PurchaseOrder: "Pedido de Compra",
        SalesOrder: "Pedido de Venda",
        PurchaseInvoice: "Nota Fiscal de Compra",
        SalesInvoice: "Nota Fiscal de Venda",
        PurchaseOrdernotfound: "Pedido de Compra não encontrado",
        Approve: "Aprovar",
        MarkasShipped: "Marcar como Enviado",
        MarkasReceived: "Marcar como Recebido",
        Marking: "Marcando...",
        PartiallyShip: "Envio Parcial",
        PartiallyReceive: "Recebimento Parcial",
        Deleting: "Excluindo...",
        Transaction: "Transação",
        Details: "Detalhes",
        Item: "Item",
        Received: "Recebido",
        Shipped: "Enviado",
        Ordered: "Pedido",
        units: "unidades",
        Overalldiscount: "Desconto Geral",
        Transactions: "Transações",
        Notransactionsfound: "Nenhuma transação encontrada",
        OrderedQty: "Qtde Pedida",
        Totalqty: "Qtde Total",
        StockingOut: "Dando saída no estoque...",
        StockingIn: "Dando entrada no estoque...",
        thiorderUpdateStuau: "este pedido? Esta ação atualizará o status.",
        TransactionDetails: "Detalhes da Transação",
        Fetchingtransactiondetails: "Buscando detalhes da transação...",
        Nodetailsfoundforthistransaction: "Nenhum detalhe encontrado para esta transação.",
        TotalBreakDown: "Detalhamento Total",
        ChangeAmount: "Valor de Troco",
        Attachments: "Anexos",
        PoNumber: "Nº do Pedido de Compra",
        SoNumber: "Nº do Pedido de Venda",
        partner: "Parceiro",
        EditPurchase: "Editar Compra",
        EditSales: "Editar Venda",
        PurchaseOrderDetails: "Detalhes do Pedido de Compra",
        SalesOrderDetails: "Detalhes do Pedido de Venda",
        OrderType: "Tipo de pedido",
        SelectOrderType: "Selecionar tipo de pedido",
        OrderTypePrepaid: "Pré-pago",
        OrderTypeCOD: "Pagar na entrega",
        OrderTypePayLater: "Pagar mais tarde",
        OrderTypePartialPayment: "Pagamento parcial",
        OrderTypeSubscription: "Assinatura",
        viewAvailabilty: 'Ver disponibilidade',
        NotReceived: "Não recebido",
        NotShipped: "Não enviado",
        PartiallyReceived: "Parcialmente recebido",
        PartiallyShipped: "Parcialmente enviado",
    },
    PriceReference: {
        HighPrice: "Preço Alto",
        LowPrice: "Preço Baixo",
        LastPrice: "Último Preço",
        LastPurchasePrice: "Último preço de compra",
        Nopricerecordsfound: "Nenhum registro de preço encontrado",
        BuyingPriceReference: "Referência de Preço de Compra",
        SellingPriceReference: "Referência de Preço de Venda",
        Viewstockinpricesfortheselectedvendorandproduct: "Ver preços de entrada de estoque para o fornecedor e produto selecionados",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Ver preços de saída de estoque para o cliente e produto selecionados"
    },
    SubscriptionLocale: {
        premiumPlan: "Plano Premium",
        heading: "Tome decisões de negócios",
        headingHighlight: "Baseadas em dados",
        subtitle: "Desbloqueie todo o poder das suas análises de negócios — sem limites, sem concessões.",
        choosePlan: "Escolha seu plano",
        monthly: "Mensal",
        annual: "Anual",
        oneTime: "Uma Vez (Mensal)",
        perMonth: "por mês",
        perYear: "por ano",
        bestValue: "Melhor valor",
        continueWith: "Continuar com",
        perMonthShort: "mês",
        perYearShort: "ano",
        troubleWithSubscription: "Problemas com a assinatura?",
        contactUs: "Entre em contato",
        paymentNotReady: "Pagamento não pronto",
        checkoutError: "ERRO NO CHECKOUT",
        pricePreviewError: "ERRO NA PRÉ-VISUALIZAÇÃO DE PREÇO",
        subNotAvailable: "Assinatura não disponível",
        subNotAvailableDesc: "As assinaturas web não estão disponíveis no seu país. Por favor, assine através do nosso aplicativo móvel ou entre em contato conosco para obter ajuda."
    },
    SubscriptionLocale2: {
        GoPro: "Ir para Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Tome decisões mais inteligentes com base em dados reais de negócios",
        ExploreProPlans: "Explorar Planos Pro"
    },
    emptyWarehouseState: {
        tips: [
            "Você pode ter múltiplos armazéns para diferentes locais físicos",
            "Cada produto rastreia o estoque por armazém de forma independente",
            'Use "Transferir Armazém" para mover estoque entre locais'
        ],
        NoWarehousesConfigured: "Nenhum Armazém Configurado",
        desc: "Comece adicionando seus armazéns (se tiver mais de um), depois adicione produtos e registre os movimentos de estoque.",
        WarehouseSetupTips: "Dicas de Configuração de Armazém",
        Noproductselected: "Nenhum produto selecionado",
        Selectaproductfromthelefttoviewlowstockdetails: "Selecione um produto à esquerda para ver detalhes de estoque baixo.",
        Chooseaproductfromthelist: "Escolha um produto da lista",
        SelectProduct: "Selecionar Produto",
        SetQuantity: "Definir Quantidade",
        Showing: "Exibindo",
        products: "produtos",
        Continue: "Continuar",
        SaveSafetyStock: "Salvar Estoque de Segurança",
        SafetyStockSaved: "Estoque de Segurança Salvo!",
        hasbeensetto: "foi definido para",
        AddAnother: "Adicionar Outro",
        Chooseaproduct: "Escolher um produto",
        Step: "Etapa",
        of: "de",
        Setsafetyquantity: "Definir quantidade de segurança",
        Complete: "Concluído",
        SafetyStockQuantity: "Quantidade de Estoque de Segurança",
        Minimumunitsdropsbelowthisnumber: "Unidades mínimas a serem sempre mantidas em estoque. Um alerta é disparado quando o estoque cai abaixo deste número.",
        NewSafetyStock: "Novo Estoque de Segurança",
        SafetyNow: "Segurança Agora",
        SettingTo: "Definindo para",
        Change: "Alterar",
        sell: "vender",
        cost: "custo",
        BulUD: "Upload/Exclusão em Massa"
    },
    SimplyLoginUI: {
        sslEncryption: "Criptografia SSL de 256 bits",
        dataPrivate: "Seus dados são 100% privados",
        worksOnDevices: "Funciona no Android e iPhone",
        realTimeSync: "Sincronização em tempo real em todos os dispositivos",
        cloudBackup: "Backup automático na nuvem",
        availableOn: "Disponível na Web, Android e iOS",
        tagline: "Seu inventário,",
        taglineEm: "lindamente simples.",
        subtitle: "Faça login para gerenciar estoque, rastrear vendas e manter seu negócio em movimento — tudo em um só lugar.",
        feature1Title: "Rastreamento de estoque em tempo real",
        feature1Desc: "Saiba exatamente o que há em cada armazém, sempre atualizado.",
        feature2Title: "Pedidos de venda e compra",
        feature2Desc: "Crie faturas, gerencie fornecedores e rastreie cada transação.",
        feature3Title: "Relatórios inteligentes",
        feature3Desc: "Relatórios financeiros, de estoque e movimentos diários num piscar de olhos.",
        feature4Title: "Sincronização em tempo real em todos os dispositivos",
        feature4Desc: "Alterações no celular aparecem instantaneamente na web — e vice-versa.",
        rating1: "Avaliado",
        rating2: "4.9/5",
        rating3: "por 10.000 empresas atacadistas",
        brandName: "Simply",
        greeting: "Olá novamente! 👋",
        noPasswordNeeded: "Faça login para acessar seu inventário — Android, iPhone e web, tudo sincronizado.",
        badge1: "Gestão de Estoque",
        badge2: "Rastreamento de Vendas",
        badge3: "Relatórios",
        trustEncryptedTitle: "Criptografado",
        trustEncryptedSub: "SSL 256 bits",
        trustPrivateTitle: "Privado",
        trustPrivateSub: "Apenas seus dados",
        trustBackedTitle: "Com backup",
        trustBackedSub: "Automático diário",
        availableOnLabel: "DISPONÍVEL EM",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Todos os dispositivos sincronizam instantaneamente em tempo real",
        securityNote: "100% seguro.",
        securityDesc: "Criptografia de nível bancário protege todos os seus dados. Lemos apenas seu nome e email — nada mais, nunca.",
        signingIn: "Entrando…",
        termsPrefix: "Ao fazer login você concorda com a",
        privacyPolicy: "Política de Privacidade",
        and: "e",
        termsOfService: "Termos de Serviço",
        google: "Entrar com Google"
    },
    BatchLocal: {
        BatchName: "Nome do Lote",
        EnterBatchName: "Digite o nome do lote",
        EnterNotes: "Digite notas",
        ExpiredDate: "Data de Validade",
        Selectexpireddate: "Selecione a data de validade",
        BatchStatus: "Status do Lote",
        CreatedDate: "Data de Criação",
        Areyousureyouwanttodeletethisbatch: "Tem certeza que deseja excluir este lote?",
        Youhavencreatedanybatchforthisproduct: "Você ainda não criou nenhum lote para este produto.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Crie seu primeiro lote para começar a rastrear o estoque por lote e validade.",
        Nobatchesyet: "Ainda não há lotes",
        Whatisbatchmanagement: "O que é gestão de lotes?",
        Howithelpsyourbusiness: "Como isso ajuda o seu negócio",
        Trackbylotnumber: "Rastrear por número de lote",
        Trackbylotnumberdesc: "Agrupe o estoque por lote do fabricante para sempre saber de qual lote veio a unidade.",
        Expirydatecontrol: "Controle de data de validade",
        Expirydatecontroldesc: "Receba alertas antes que o estoque expire. Venda os lotes mais antigos primeiro e reduza o desperdício automaticamente.",
        Fulltraceability: "Rastreabilidade completa",
        Fulltraceabilitydesc: "Veja exatamente qual lote foi usado em cada transação — ótimo para auditorias e recalls.",
        Supplierwisestock: "Estoque por fornecedor",
        Supplierwisestockdesc: "Separe o estoque de fornecedores diferentes mesmo para o mesmo produto. Compare qualidade lote por lote.",
        Createyourfirstbatchbutton: "Crie seu primeiro lote",
        Nomatchesfound: "Nenhuma correspondência encontrada",
        NomatchesfounddescBefore: "Não encontramos nenhum lote correspondente a ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Limpar pesquisa",
        Nohistoryfoundthisbatch: "Nenhum histórico encontrado para este lote",
        ComprehensiveDetails: "Detalhes Completos",
        History: "Histórico",
        InBatch: "No Lote",
        Noproductfoundinthisbatch: "Nenhum produto encontrado neste lote",
        SelectBatch: "Selecionar Lote",
        available: "disponível",
        Searchbatches: "Buscar lotes...",
        Expires: "Vence em",
        Nobatchesfound: "Nenhum lote encontrado",
        ManageBatches: "Gerenciar Lotes",
        Batchmanagement: "Gestão de Lotes",
        Trackstockexpiry: "Rastrear estoque por lote e validade",
        Turnoffbatchmanagement: "Desativar gestão de lotes?",
        Yourgsafe: "Seus dados de lote existentes permanecem seguros.",
        Reenableanytimefrom: "Você pode reativar a qualquer momento a partir da",
        Otherstab: "aba Outros",
        AddBatch: "Adicionar Lote",
        Total: "Total",
        AssignProduct: "Atribuir Produto",
        EditProductAssignment: "Editar Atribuição de Produto",
        AssignProducttoBatch: "Atribuir Produto ao Lote",
        Updateproductconfiguration: "Atualizar configuração do produto",
        Step1of2: "Etapa 1 de 2",
        Step2of2: "Etapa 2 de 2",
        Selectvariantwarehouse: "Selecionar variante e armazém",
        SelectedProduct: "Produto Selecionado",
        AssignQuantity: "Atribuir Quantidade",
        BatchInfo: "Informações do Lote",
        Wecouldnthisproductidentifier: "Não encontramos lotes associados a este identificador de produto.",
        NoActiveBatches: "Nenhum Lote Ativo",
        Endofresults: "Fim dos resultados",
        Expiry: "Validade",
        BatchManagementDescription: "Rastreie o estoque por número de lote e data de validade. Garante a ordem LIFO / FEFO correta em cada saída de estoque — sem necessidade de seleção manual.",
        Expiryalerts: "Alertas de Validade",
        Autonotifications: "Notificações Automáticas",
        LIFOsorting: "Ordenação LIFO / FEFO",
        Smartstockflow: "Fluxo de Estoque Inteligente",
        Perout: "Saída de Estoque por Lote",
        Precisiontracking: "Rastreamento de Precisão",
        NeedsReview: "Precisa de revisão",
        Pending: "Pendente",
        Rejected: "Rejeitado",
        Approved: "Aprovado",
        WaitingForApproval: "Aguardando aprovação",
        WaitingForApprovalDesc: "Seu proprietário irá revisar e aprovar este lote em breve.",
        BatchRejected: "Lote rejeitado",
        BatchRejectedDesc: "Seu proprietário rejeitou este lote.",
        Reason: "Motivo",
        Approve: "Aprovar",
        Reject: "Rejeitar",
        ConfirmApproveTitle: "Aprovar lote",
        ConfirmRejectTitle: "Rejeitar lote",
        ConfirmApprovalAction: "Tem certeza de que deseja {action} este lote? Esta ação atualizará seu status.",
        ReasonOptional: "Motivo (Opcional)",
        EnterReasonPlaceholder: "Digite um motivo para {action} (opcional)",
        Processing: "Processando...",
        BatchActivatedSuccess: "Lote ativado com sucesso",
        BatchDeactivatedSuccess: "Lote desativado com sucesso",
        BatchDeletedSuccess: "Lote excluído com sucesso",
        BatchApprovedSuccess: "Lote aprovado com sucesso",
        BatchRejectedSuccess: "Lote rejeitado com sucesso",
        SearchByBatchName: "Buscar por nome do lote...",
        YesTurnOff: "Sim, desligar",
        KeepItOn: "Manter ligado"
    },
    CategoryNewL: {
        TotalCategories: "Total de Categorias",
        lastaddedcategory: "Última categoria adicionada",
        acrossalltypes: "em todos os tipos",
        MostRecent: "Mais Recente",
        YesD: "Sim, Excluir",
        AllAssociated: "Todos os produtos associados podem ser afetados"
    },
    OverDas: {
        movestockbetweenlocations: "Mover estoque",
        no_activity_yet: "Nenhuma atividade ainda",
        no_activity_sub: "Vendas, compras, movimentos de estoque e devoluções aparecerão aqui em tempo real.",
        make_first_sale: "Fazer a primeira venda",
        add_stock: "Adicionar estoque",
        all_stock_healthy: "Todos os níveis de estoque estão saudáveis",
        all_stock_healthy_sub: "Nenhum item está acabando. Defina limites mínimos nos produtos para receber alertas aqui.",
        set_stock_thresholds: "Definir limites de estoque",
        no_warehouses_setup: "Nenhum armazém configurado",
        no_warehouses_setup_sub: "Adicione um armazém para começar a rastrear onde seu estoque está armazenado e gerenciar locais.",
        add_first_warehouse: "Adicionar primeiro armazém",
        Customer: "Clientes",
        PurchasevsSales: "Compras vs Vendas",
        Financialperformancechart: "Gráfico de desempenho financeiro",
        QuickActions: "Ações rápidas",
        Frequentlyused: "Usadas com frequência",
        Addinventory: "Adicionar inventário",
        Dispatchitems: "Despachar itens",
        Addorder: "Adicionar pedido",
        Newitem: "Novo item",
        Inventoryaccess: "Acesso ao inventário",
        Itemsneedingreorder: "Itens que precisam de reposição",
        Latesttransactions: "Últimas transações",
        Operationalsummary: "Resumo operacional",
        ViewAll: "Ver tudo",
        Manage: "Gerenciar",
        RecentActivity: "Atividade recente",
        LowStockAlerts: "Alertas de estoque baixo",
        Primary: "Principal",
        TotalWarehouses: "Total de armazéns"
    },
    SerialLocal: {
        ShowOrHideFields: "Mostrar ou ocultar campos",
        ShowOrHideFieldsDesc: "Toque em qualquer item abaixo para incluí-lo ou removê-lo da fatura impressa. As alterações são aplicadas instantaneamente.",
        Manufacturesettings: "Configurações de fabricação",
        Showbuyingprice: "preço de compra / custo do produto",
        Showadditionalcost: "custo adicional",
        Costbreakdown: "Detalhamento de custos",
        Unitcost: "Custo unitário",
        Rawmaterialstotal: "Total de matérias-primas",
        Confirmentry: "Confirmar entrada",
        SaveSerials: "Salvar números de série",
        SerialNumber: "Número de série",
        selected: "selecionado",
        added: "adicionado",
        Serialnumbers: "Números de série",
        ResetAll: "Redefinir tudo",
        Wecouldnfindthis: "Não encontramos nenhum número de série disponível para este produto.",
        Nounitsfound: "Nenhuma unidade encontrada",
        Searchingserialnumbers: "Procurando números de série...",
        Scanorenterstock: "Escaneie ou insira números de série para novo estoque",
        Whataserialnumber: "O que é um número de série?",
        Auniqueidentifieryourinventorylifecycle: "Um identificador único por unidade — permite rastrear cada item individual ao longo do ciclo de vida do inventário.",
        Trackedstockout: "Saída de estoque rastreada",
        Chooseexactlyselected: "Escolha exatamente quais números de série estão saindo. Apenas os seriais estocados para este produto são mostrados — a quantidade trava assim que você selecionar ",
        SelectSerialstoout: " - Selecionar números de série para saída",
        Thisinvoicegeneratedusingwwwsimplstockco: "Esta fatura foi gerada usando www.simplstock.co",
        AuthorizedSignature: "Assinatura autorizada",
        Invoicesettings: "Configurações da fatura",
        Draw: "Desenhar",
        Taptoselectordeselectitems: "Toque para selecionar ou desselecionar itens",
        Thissignaturewillbeadded: "Esta assinatura será adicionada na parte inferior da sua fatura impressa.",
        SignatureOptions: "Opções de assinatura",
        Upload: "Enviar",
        DrawSignature: "Desenhar assinatura",
        UploadSignature: "Enviar assinatura",
        Clear: "Limpar",
        ShowStaffName: "nome do funcionário",
        ShowSKU: "SKU",
        ShowBusinessName: "nome da empresa",
        ShowProductName: "nome do produto",
        ShowBusinessPhoneNumber: "telefone",
        ShowBusinessEmail: "e-mail",
        ShowBusinessAddress: "endereço",
        ShowProductImage: "imagem do produto",
        ShowPaymentDetails: "detalhes de pagamento",
        ShowCategory: "categoria",
        ShowVariant: "variante",
        ShowWarehouse: "armazém",
        ShowAttributes: "atributos",
        ShowQuantity: "quantidade",
        ShowDiscount: "desconto",
        ShowTax: "imposto",
        ShowPrice: "preço",
        ShowTotalPrice: "preço total do produto",
        ShowExpenses: "despesas",
        ShowSignature: "assinatura",
        ShowNote: "nota",
        showAttachment: "anexo",
        ShowSerialNumber: "número de série",
        Invoicesettingsapplied: "Configurações da fatura aplicadas. Verifique a fatura para ver as alterações.",
        EnterSerialNumber: "Inserir número de série",
    },
    FewLocal: {
        SelectBin: "Selecionar Bin",
        Live: "Ao Vivo",
        Monitorinventorystocklevels: "Monitorar inventário, movimentação e níveis de estoque",
        StockControlCentre: "Centro de Controle de Estoque",
        Nochartdataavailable: "Nenhum dado de gráfico disponível",
        Disabled: "Desabilitado",
        Enabled: "Habilitado"
    },
    Bin: {
        Bin: "Bin",
        Add: "Adicionar",
        NoBinsAddedYet: "Nenhum bin adicionado ainda",
        BinLocationsHelp: "As localizações de bin ajudam você a rastrear o estoque pela posição exata dentro deste armazém — sem mais buscas.",
        NameThemByPosition: "Nomeie-os por posição:",
        AddBinLocation: "Adicionar Localização de Bin",
        BinLocations: "localizações de bin",
        BinNameRequired: "Nome do bin é obrigatório",
        EditBin: "Editar Bin",
        AddBin: "Adicionar Bin",
        EnterBinName: "Nome do Bin",
        EnterBinNamePlaceholder: "Digite o nome do bin",
        BinStatus: "Status do Bin",
        BinNotes: "Notas",
        EnterBinNotesPlaceholder: "Adicione algumas notas...",
        ViewInventory: "Ver Inventário",
        Inventory: "Inventário",
        TrymatchingadifferentSKUname: "Tente com um SKU ou nome diferente.",
        Thisbinlocationcurrentlyempty: "Esta localização de bin está atualmente vazia.",
        Loadingbins: "Carregando bins...",
        bins: "bins",
        ManageBin: "Gerenciar Bin",
        Print: "Imprimir",
        SBin: "Bin Origem",
        DBin: "Bin Destino"
    },
    WarehouseExcel: {
        title: "Carregar Armazéns & Locais de Bin",
        description: "Siga os passos abaixo para criar em massa armazéns junto com seus locais de bin usando um arquivo Excel.",
        bulkUploadGuide: "Guia de Upload em Massa",
        step1: "Etapa 1",
        downloadTemplate: "Baixar modelo Excel",
        downloadTemplateDesc: "Baixe o modelo oficial com todos os cabeçalhos de coluna necessários. Não renomeie ou remova nenhuma coluna.",
        downloadTemplateBtn: "Baixar Modelo",
        step2: "Etapa 2",
        fillExcelFile: "Preencher o arquivo Excel",
        fillExcelDesc: "Cada linha representa um armazém. Preencha todas as colunas — para locais de bin, insira todos os nomes separados por vírgula na coluna <code>Bin Names</code>.",
        step3: "Etapa 3",
        thingsToKeepInMind: "Coisas para ter em mente",
        rulesDesc: "Antes de fazer upload, certifique-se de que seu arquivo segue estas regras.",
        step4: "Etapa 4",
        uploadYourFile: "Fazer upload do seu arquivo",
        uploadDesc: "Após preencher, faça upload do arquivo abaixo. O sistema criará todos os armazéns e locais de bin automaticamente.",
        rules: ["Uma linha por armazém", "Nomes de bin separados por vírgula em uma única célula", "Não renomear cabeçalhos de coluna", "Nomes de bin duplicados por armazém são ignorados", "Número de telefone com código do país", "Apenas arquivos .xlsx ou .xls aceitos"],
        dropFileHere: "Solte seu arquivo Excel aqui",
        supports: "Suporta .xlsx e .xls — máximo 10 MB",
        chooseFileUpload: "Escolher Arquivo & Fazer Upload",
        parsing: "Analisando arquivo...",
        invalidFileType: "Tipo de arquivo inválido. Por favor, faça upload de um arquivo Excel.",
        noData: "Nenhum dado encontrado no Excel",
        failedToRead: "Falha ao ler o arquivo Excel",
        unableToRead: "Não foi possível ler o arquivo.",
        reviewTitle: "Revisar Dados dos Armazéns",
        reviewSubtitle: "Verificação final antes de importar para o seu negócio.",
        changeFile: "Alterar Arquivo",
        rowsFound: "linhas encontradas",
        cancel: "Cancelar",
        finalizeImport: "Finalizar & Importar",
        importing: "Importando...",
        success: "Sucesso",
        allWarehouseUploadedSuccess: "Todos os armazéns foram carregados com sucesso",
        failed: "Falhou",
        bulkUploadFailed: "Upload em massa falhou",
        error: "Erro",
        binNamesNote: "Na coluna <strong>Bin Names</strong>, insira todos os locais de bin para um armazém em uma única célula, separados por vírgula — ex: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Nome do Armazém", email: "Email", phoneNumber: "Número de Telefone", location: "Localização", binNames: "Nomes de Bin" }
    },
    VariantTemplate: {
        VariantTemplates: "Modelos de Variantes",
        Managereusablevariantpatterns: "Gerenciar padrões de variantes reutilizáveis",
        BinTransferHistory: "Histórico de Transferência de Bin",
        Trackmovementsacrossbins: "Rastrear movimentos entre bins",
        SerialNumberHistory: "Histórico de Números de Série",
        Trackproductserialnumberactivity: "Rastrear atividade de números de serie do produto",
        Period: "Período",
        Nohistoryfound: "Nenhum histórico encontrado",
        Searchserialnumbers: "Buscar números de serie...",
        SerialNumbersHistory: "Histórico de Números de Série",
        Serialnumberhistoryglance: "Histórico de números de série em um relance.",
        Noserialnumbersfound: "Nenhum número de série encontrado",
        Noactivityhistoryfound: "Nenhum histórico de atividade encontrado",
        Statussetto: "Status definido como",
        Timeline: "Linha do tempo",
        Managereusableproductvariantpatterns: "Gerenciar padrões de variantes de produtos reutilizáveis.",
        DeleteTemplate: "Excluir Modelo",
        Areyousureyouwanttemplate: "Tem certeza que deseja excluir este modelo?",
        CreateNewTemplate: "Criar Novo Modelo",
        CreateTemplate: "Criar Modelo",
        EditTemplate: "Editar Modelo",
        UnlimitedTemplates: "Modelos ilimitados",
        CreateAsManyTemplates: "Crie quantos modelos precisar — Roupas, Calçados, Eletrônicos e mais.",
        PickWhileAddingProduct: "Escolher ao adicionar produto",
        OpenTemplateLibrary: "Abra sua biblioteca de modelos e selecione nomes de variantes em segundos.",
        MixFromMultipleTemplates: "Misturar de múltiplos modelos",
        SelectFromMultipleTemplates: "Selecione nomes de variantes de mais de um modelo para um único produto — totalmente flexível.",
        EditAnytime: "Editar a qualquer momento",
        RenameTemplatesAnytime: "Renomeie modelos, adicione ou remova nomes de variantes sempre que seu catálogo mudar.",
        StayConsistent: "Mantenha a consistência",
        SameVariantNamesAcrossAll: "Mesmos nomes de variantes em todos os produtos. Sem erros de digitação, sem duplicatas, sem adivinhação.",
        BuildOnceUseEverywhere: "Crie uma vez, use em todos os lugares",
        StopReEnteringVariantNames: "Pare de digitar novamente os mesmos nomes de variantes para cada produto. Crie um modelo, atribua nomes de variantes e reutilize instantaneamente.",
        Updateexistingvariantcombinations: "Atualizar combinações de variantes existentes",
        Definenewvariantcombinations: "Definir novas combinações de variantes",
        TemplateName: "Nome do Modelo",
        AddVariantOptions: "Adicionar Opções de Variante",
        SmallMedium: "ex: Pequeno, Médio...",
        VariantsList: "Lista de Variantes",
        Nooptionsaddedyet: "Nenhuma opção adicionada ainda",
        SaveTemplate: "Salvar Modelo",
        egSizesColorsetc: "ex: Tamanhos de Camiseta, Cores, etc.",
        Pleaseentertemplatename: "Por favor, insira o nome do modelo",
        Pleaseaddatleastonevariantoption: "Por favor, adicione pelo menos uma opção de variante",
        Templateupdatedsuccessfully: "Modelo atualizado com sucesso",
        Templatecreatedsuccessfully: "Modelo criado com sucesso",
        Failedtosavetemplate: "Falha ao salvar o modelo",
        Transfer: "Transferir",
        Editassignment: "Editar atribuição",
        Updateproductdetailsinbin: "Atualizar detalhes do produto no bin",
        Editinginbin: "Editando no bin",
        ConfirmUpdate: "Confirmar Atualização",
        ConfirmAssign: "Confirmar Atribuição",
        Assignanotherproduct: "Atribuir outro produto",
        TransferBin: "Transferir Bin",
        SourceBin: "Bin de Origem",
        DestinationBin: "Bin de Destino",
        SelectSourceBin: "Selecionar Bin de Origem",
        SelectDestinationBin: "Selecionar Bin de Destino",
        Unit: "Unidade",
        ManageVariant: "Gerenciar Variante",
        CreateSKUvariationsyourproduct: "Criar variações de SKU para seu produto",
        Assigningvariationsto: "Atribuindo variações a",
        Novariantsaddedyet: "Nenhuma variante adicionada ainda",
        AddedVariants: "Variantes Adicionadas",
        AddVariantsfromTemplate: "Adicionar Variantes do Modelo",
        Pickatemplateandselectvariantnames: "Escolha um modelo e selecione nomes de variantes",
        ChooseaTemplate: "Escolher um Modelo",
        Selectvariantnamestoadd: "Selecionar nomes de variantes para adicionar",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Selecione um modelo para escolher nomes de variantes. Você pode adicionar de múltiplos.",
        Loadingtemplates: "Carregando modelos...",
        Backtotemplates: "Voltar aos modelos",
        Selectallindividualadd: "Selecione todos ou nomes de variantes individuais para adicionar.",
        VariantNames: "Nomes de Variantes",
        MediaDescription: "Mídia & Descrição",
        Addattachmentsandproductnotes: "Adicionar anexos e notas do produto",
        ProductMedia: "Mídia do Produto"
    },
    AddProductGuide: {
        title: "Adicionar quantidade inicial após salvar",
        description: "Os produtos não têm um campo de quantidade aquí. Após salvar, use 'Entrada de Estoque' para registrar seu estoque inicial — com controle total sobre localização e rastreamento.",
        steps: {
            quantity: { title: "Quantidade", sub: "Definir contagem de estoque inicial" },
            binLocation: { title: "Localização do Bin", sub: "Corredor, rack, prateleira — ex: A-01-03" },
            serialNumbers: { title: "Números de série", sub: "Rastrear cada unidade individualmente" },
            warehouse: { title: "Armazém", sub: "Em qual localização está armazenado" },
            batchExpiry: { title: "Lote / Validade", sub: "Agrupar estoque por número de lote" }
        },
        actions: { close: "Fechar" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Nenhum Pedido de Transferência Encontrado",
        Itemshistory: "Itens que você transfere entre armazéns aparecerão aqui para rastreamento e histórico.",
        CreateTransfer: "Criar Transferência"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Toque no produto para Fabricar",
        Selectproductfrombelow: "Selecione o produto na lista abaixo",
        SetupANewProduct: "Configurar um Novo Produto",
        DefineAProductAdditsrawmaterial: "Definir um Produto e adicionar as suas matérias-primas",
        ManufacturingSetup: "Configuração de Fabricação",
        Pickproducttodefineitsproductiondetails: "Escolha o produto para definir os seus detalhes de produção",
        ConfigureManufacturing: "Configurar Fabricação",
        SelectRawMaterial: "Selecionar Matéria-prima",
        NoRawMaterials: "Sem Matérias-primas",
        Definecomponentsneededtoproduct: "Definir os componentes necessários para fabricar este produto.",
        NoAdditionalCosts: "Sem Custos Adicionais",
        Addlaboroverheadlogisticalcharges: "Adicione custos de mão de obra, gerais ou logísticos.",
        AddAdditionalCost: "Adicionar Custo Adicional",
        AddCost: "Adicionar Custo",
        TotalPrice: "Preço Total",
        SelectCharges: "Selecionar Encargos",
        EnterEstimatedCost: "Inserir Custo Estimado",
        QtyRequried: "Qtd Necessária",
        Manufacturing: "Fabricação",
        Outputfinishedgoodsdestination: "Destino dos produtos acabados",
        Manufacturingquantity: "Quantidade de fabricação",
        Storefinishedgoodsat: "Armazenar produtos acabados em",
        Rawmaterials: "Matérias-primas",
        StockSelection: "Seleção de Estoque",
        AdditionalCosts: "Custos Adicionais",
        Quantityconsume: "Quantidade consumida",
        Totalmanufacturingcost: "Custo total de fabricação",
        Sumofrawmaterialcosts: "Soma de todos os custos de matéria-prima",
        CustomManufacturingCharge: "Encargo de Fabricação Personalizado",
        Addextralikelaboroverheadrepairs: "Adicione custos extras como mão de obra, gerais ou reparos.",
        CalculatedTotal: "Total Calculado",
        AddRawMaterial: "Adicionar Matéria-prima",
        ConfigureRawMaterial: "Configurar Matéria-prima",
        Thisoutputunit: "Esta é a quantidade base necessária por unidade de saída.",
        ChangeProduct: "Alterar Produto",
        AddtoList: "Adicionar à Lista",
        ManufacturedSuccessfully: "Fabricado com Sucesso",
        Manufacture: "Fabricação",
        EditDeleteHistory: "Histórico de Editar/Excluir",
        ManageOrder: "Gerenciar Pedido",
        ManageBatch: "Gerir lote",
        Paymentnotavailablehere: "Pagamento não disponível aqui",
        Thisrecordisanorderorderitself: "Este registro é de um pedido. O pagamento só pode ser registrado a partir do pedido.",
        Torecorpaymenttheorderthethere: "Para registrar um pagamento, vá ao pedido vinculado e use a opção <b>Registrar Pagamento</b> lá.",
        GotoOrder: "Ir ao pedido"
    },
    CustomerExcel: {
        title: "Carregar Clientes",
        description: "Siga as etapas abaixo para criar clientes em massa usando um arquivo Excel.",
        bulkUploadGuide: "Guia de Carregamento em Massa",
        step1: "Passo 1",
        downloadTemplate: "Baixar Modelo Excel",
        downloadTemplateDesc: "Obtenha o modelo oficial com todos os cabeçalhos de coluna necessários.",
        downloadTemplateBtn: "Baixar Modelo",
        step2: "Passo 2",
        fillExcelFile: "Preencher o arquivo Excel",
        fillExcelDesc: "Cada linha representa um cliente. Preencha todas as colunas conforme necessário.",
        step3: "Passo 3",
        thingsToKeepInMind: "Coisas a ter em mente",
        rulesDesc: "Antes de carregar, certifique-se de que seu arquivo siga estas regras para evitar erros.",
        step4: "Passo 4",
        uploadYourFile: "Carregar seu arquivo",
        uploadDesc: "Depois de preencher, carregue o arquivo abaixo. O sistema criará todos os clientes automaticamente.",
        rules: [
            "Apenas uma linha por cliente",
            "Não altere o nome dos cabeçalhos das colunas",
            "Número de contato com código do país",
            "Apenas arquivos .xlsx ou .xls são aceitos"
        ],
        dropFileHere: "Arraste seu arquivo Excel aqui",
        supports: "Suporta .xlsx e .xls — máximo 10 MB",
        chooseFileUpload: "Escolher Arquivo e Carregar",
        parsing: "Analisando arquivo...",
        invalidFileType: "Tipo de arquivo inválido. Carregue um arquivo Excel.",
        noData: "Nenhum dado encontrado no Excel",
        failedToRead: "Falha ao ler o arquivo Excel",
        unableToRead: "Não foi possível ler o arquivo.",
        reviewTitle: "Revisar Dados dos Clientes",
        reviewSubtitle: "Verificação final antes de importar para o seu negócio.",
        changeFile: "Alterar Arquivo",
        rowsFound: "linhas encontradas no arquivo",
        cancel: "Cancelar",
        finalizeImport: "Finalizar e Importar",
        importing: "Importando...",
        success: "Sucesso",
        allCustomerUploadedSuccess: "Todos os clientes foram carregados com sucesso",
        failed: "Falhou",
        bulkUploadFailed: "O carregamento em massa falhou",
        error: "Erro",
        headers: {
            customerName: "Nome do Cliente",
            phoneNumber: "Contato",
            address: "Endereço",
            note: "Nota"
        }
    },
    SupplierExcel: {
        title: "Carregar Fornecedores",
        description: "Siga as etapas abaixo para criar fornecedores em massa usando um arquivo Excel.",
        bulkUploadGuide: "Guia de Carregamento em Massa",
        step1: "Passo 1",
        downloadTemplate: "Baixar Modelo Excel",
        downloadTemplateDesc: "Obtenha o modelo oficial com todos os cabeçalhos de coluna necessários.",
        downloadTemplateBtn: "Baixar Modelo",
        step2: "Passo 2",
        fillExcelFile: "Preencher o arquivo Excel",
        fillExcelDesc: "Cada linha representa um fornecedor. Preencha todas as colunas conforme necessário.",
        step3: "Passo 3",
        thingsToKeepInMind: "Coisas a ter em mente",
        rulesDesc: "Antes de carregar, certifique-se de que seu arquivo siga estas regras para evitar erros.",
        step4: "Passo 4",
        uploadYourFile: "Carregar seu arquivo",
        uploadDesc: "Depois de preencher, carregue o arquivo abaixo. O sistema criará todos os fornecedores automaticamente.",
        rules: [
            "Apenas uma linha por fornecedor",
            "Não altere o nome dos cabeçalhos das colunas",
            "Número de contato com código do país",
            "Apenas arquivos .xlsx ou .xls são aceitos"
        ],
        dropFileHere: "Arraste seu arquivo Excel aqui",
        supports: "Suporta .xlsx e .xls — máximo 10 MB",
        chooseFileUpload: "Escolher Arquivo e Carregar",
        parsing: "Analisando arquivo...",
        invalidFileType: "Tipo de arquivo inválido. Carregue um arquivo Excel.",
        noData: "Nenhum dado encontrado no Excel",
        failedToRead: "Falha ao ler o arquivo Excel",
        unableToRead: "Não foi possível ler o arquivo.",
        reviewTitle: "Revisar Dados dos Fornecedores",
        reviewSubtitle: "Verificação final antes de importar para o seu negócio.",
        changeFile: "Alterar Arquivo",
        rowsFound: "linhas encontradas no arquivo",
        cancel: "Cancelar",
        finalizeImport: "Finalizar e Importar",
        importing: "Importando...",
        success: "Sucesso",
        allSupplierUploadedSuccess: "Todos os fornecedores foram carregados com sucesso",
        failed: "Falhou",
        bulkUploadFailed: "O carregamento em massa falhou",
        error: "Erro",
        headers: {
            supplierName: "Nome do Fornecedor",
            phoneNumber: "Contato",
            bankName: "Nome do Banco",
            accountHolderName: "Nome do Titular",
            accountNumber: "Número da Conta",
            note: "Nota"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "Substituído por",
        Noreplacementhistoryfound: "Nenhum histórico de substituição encontrado",
        Noreturnhistoryfound: "Nenhum histórico de devolução encontrado",
        Productbeingreturned: "Produto sendo devolvido",
        Required: "Obrigatório",
        Selectreturnedproduct: "Selecionar produto devolvido",
        Searchnamescanbarcode: "Buscar por nome, SKU ou ler código de barras",
        Browse: "Procurar",
        Stockhandling: "Manuseio de entrada de estoque",
        Stockinreturnedproduct: "Dar entrada do produto devolvido no estoque",
        Ontoinventory: "Ligado — o item devolvido será adicionado novamente ao inventário",
        Offreturnedonly: "Desligado — o item será registrado apenas como devolvido",
        Usedrestock: "Usado para calcular o ajuste de lucro ao repor estoque",
        Willaddedbackconfirmation: "Será adicionado novamente ao inventário mediante confirmação",
        Returnreason: "Motivo da devolução",
        Optional: "Opcional",
        SelectReason: "Selecionar motivo",
        Additionalnotes: "Notas adicionais",
        Describeofcustomerexplanation: "Descreva a condição do item devolvido, qualquer dano visível, a explicação do cliente...",
        Requiredmustfilledcontinue: "Os campos obrigatórios devem ser preenchidos para continuar",
        Reviewdetailsbeforeconfirming: "Revise os detalhes antes de confirmar",
        Replacementproductwilldeductedinventoryconfirmation: "O produto de substituição será deduzido do seu inventário mediante confirmação.",
        Choosereplacementproduct: "Escolher produto de substituição",
        Willdeductedfrominventoryconfirm: "Será deduzido do inventário mediante confirmação",
        Thesewillattachedothereturnrecord: "Estas imagens serão anexadas ao registro de devolução",
        Replacementitem: "Item de substituição",
        Addanotherproduct: "Adicionar outro produto",
        Replacementproductwillbe: "O produto de substituição será",
        deducted: "deduzido",
        fromyourinventoryconfirmation: "do seu inventário mediante confirmação.",
        productadjustedusingprice: "O produto devolvido será reposto e o lucro ajustado usando o preço de venda original.",
        Willloggedreturnedonlynotrestocked: "Será registrado apenas como devolvido — não será reposto",
        Returnonly: "Apenas devolução",
        Imagesofreturnedproduct: "Imagens do produto devolvido",
        Returnedproductwill: "O produto devolvido",
        not: "não",
        berestockedloggedreturnedonly: "será reposto — registrado apenas como devolvido.",
        AddImage: "Adicionar imagem",
        STOCKIN: "ENTRADA DE ESTOQUE",
        LOGONLY: "APENAS REGISTRO",
        ContinuetoReview: "Continuar para Revisão →",
        Confirmreplacement: "Confirmar substituição",
        Confirmreturn: "Confirmar devolução",
        Filldetailsbelowproceed: "Preencha os detalhes abaixo para continuar",
        Review: "Revisão",
        editdetails: "Editar detalhes",
        Configurereturndetails: "Configurar detalhes da devolução",
        Configurereplacementdetails: "Configurar detalhes da substituição",
        SelectSource: "Selecionar Origem",
        Returning: "Devolvendo",
        Replacement: "Substituição",
        WalkCustomer: "Cliente Direto",
        RETURNEDPRODUCT: "PRODUTO DEVOLVIDO",
        REPLACEMENTPRODUCT: "PRODUTO DE SUBSTITUIÇÃO",
        STOCKOUT: "SAÍDA DE ESTOQUE",
        Netinventoryimpact: "Impacto líquido no inventário",
        Replacementitemcost: "Custo do item de substituição",
        Returneditemrestockvalue: "Valor de reposição do item devolvido",
        PROFITINVENTORYSUMMARY: "RESUMO de LUCRO E INVENTÁRIO",
        Inventoryaction: "Ação de inventário",
        Valuededucted: "Valor deduzido",
        Profitadjustment: "Ajuste de lucro",
        stockedout: " saída de estoque",
        restocked: " reposto",
        Noaction: "Sem ação",
        Valuebeingreturned: "Valor devolvido",
        Willberestocked: "Será reposto",
        Willbe: "Será",
        logged: "registrado",
        ON: "LIGADO",
        OFF: "DESLIGADO",
        Linked: "Vinculado",
        Pleaseselectreturnedproduct: "Por favor selecione um produto devolvido",
        Quantityrequired: "A quantidade é obrigatória",
        Buyingpricerequired: "O preço de compra é obrigatório",
        Pleaseaddleastreplacementproduct: "Por favor adicione pelo menos um produto de substituição",
        Pleaseconfigurereturnedproductdetails: "Por favor configure os detalhes do produto devolvido",
        Pleaseselectcustomer: "Por favor selecione um cliente",
        Returndateisrequired: "A data de devolução é obrigatória",
        Pleasefillallrequiredfields: "Por favor preencha todos os campos obrigatórios",
        Wildeductedfrominventory: "Será deduzido do inventário",
        Currentprice: "Preço atual",
        Defectivedamaged: "Defeituoso / danificado",
        Wrongitemreceived: "Item errado recebido",
        Customerchangedmind: "Cliente mudou de ideia",
        Sizefitissue: "Problema de tamanho / ajuste",
        Notasdescribed: "Não conforme descrito",
        Other: "Outro",
        Originalsaleprice: "Preço de venda original (lucro ajustado)",
        Addedbackinventory: "Adicionado de volta ao estoque",
        Notaddedinventory: "Não adicionado ao estoque",
        replacedwith: "substituído por",
        deductedfrominventory: "deduzido do estoque",
        RETURNWITHSTOCKIN: "DEVOLUÇÃO · COM STOCK-IN",
        RETURNNOSTOCKIN: "DEVOLUÇÃO · SEM STOCK-IN",
        MULTIPLEREPLACEMENTS: "MÚLTIPLAS SUBSTITUIÇÕES",
        SINGLEREPLACEMENT: "SUBSTITUIÇÃO ÚNICA",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "DEVOLVIDO · STOCK IN",
        REPLACEMENTSTOCKOUT: "SUBSTITUIÇÃO · STOCK OUT",
        Returnonlylogsthisentry: "A devolução registra apenas esta entrada —",
        nostockwillbeaddedorremoved: "nenhum estoque será adicionado ou removido",
        frominventory: "do inventário.",
        Whentousethis: "Quando usar isto:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Use Devolução no final do dia para registrar itens enviados para vendas que voltaram danificados ou inutilizáveis — itens que você deseja rastrear, mas não pode adicionar de volta ao inventario.",
        Youcanviewallpastreturnentriesin: "Você pode ver todas as entradas de devolução passadas em",
        ReturnHistory: "Histórico de devoluções",
        underthe: "sob a guia",
        Others: "Outros",
        tab: "aba.",
        Negativestocktransactiondisabled: "Transações de ações negativas estão desativadas."
    },
    NewRLocal: {
        Originalsaleprice: "Preço de venda original",
        Editinghistoryonlyinventorystaysunchanged: "Editando apenas o histórico — o inventário permanece inalterado.",
        Changeshereupdatethisdetailsquantitiesaffected: "As alterações feitas aqui atualizam apenas os detalhes deste registro (motivo, data, notas). Suas quantidades reais de estoque, locais de bin e dados de produtos não são afetados.",
        Needtofixinventorylevelsinstead: "Precisa corrigir os níveis de estoque em vez disso?",
        AdjustStock: "Ajustar Estoque",
        Refund: "Reembolso",
        ImportantNote: "Nota Importante",
        Pleasereviewbeforecontinuing: "Por favor, revise antes de continuar",
        Onceshippedreceivedanyupdatesmadeorder: "Assim que um pedido for enviado ou recebido, quaisquer atualizações feitas no pedido não serão refletidas no histórico de transações.",
        Thisundone: "Isso removerá permanentemente o pedido. Esta ação não pode ser desfeita.",
        Inventorywilladjustedautomatically: "O inventário não será ajustado automaticamente",
        Deletingthisreversevedshippedyouwillneed: "A exclusão disso não reverte nenhuma alteração de estoque. Se os itens já foram recebidos/enviados, você precisará",
        reflectthecorrectstocklevels: "para refletir os níveis de estoque corretos.",
        manuallyadjustyourinventory: "ajustar manualmente seu inventário",
        Addremovestockforitemsthatwereshipped: "Adicionar/remover estoque para itens que foram enviados",
        Addremovestockforitemsthatwerereceived: "Adicionar/remover estoque para itens que foram recebidos",
        Updatecostrecordspaymentwaalreadymade: "Atualizar registros de custos se o pagamento já foi feito",
        Reconcilerecordsandoutstandingpayments: "Reconciliar registros e pagamentos pendentes"
    },
    ReceivablesLocal: {
        Receivables: "Contas a Receber",
        Manageandtrackcustomerduebalances: "Gerenciar e rastrear saldos devidos de clientes",
        Viewcustomerduebalancereport: "Ver relatório de saldo devido de clientes",
        Viewsupplierduebalancereport: "Ver relatório de saldo devido de fornecedores",
        DueBalance: "Saldo Devido",
        Unpaid: "Não Pago",
        PartiallyPaid: "Parcialmente Pago",
        Paid: "Pago",
        HighestBalance: "Maior Saldo",
        LowestBalance: "Menor Saldo",
        Filldetailsrecordpayment: "Preencha os detalhes para registrar o pagamento",
        NewPaymentEntry: "Nova Entrada de Pagamento",
        EditPaymentEntry: "Editar Entrada de Pagamento",
        Nosuppliersfound: "Nenhum fornecedor encontrado",
        Nocustomersfound: "Nenhum cliente encontrado",
        LowtoHigh: "Menor para Maior",
        HightoLow: "Maior para Menor",
        AttachmentUploadedSc: "Anexo enviado com sucesso",
        AttachmentUploadedF: "Falha ao enviar o anexo",
        Pay: "Pagar",
        NoBillsFound: "Nenhuma Fatura Encontrada",
        Thiscustomerhasunpaidbills: "Este cliente não tem faturas pendentes.",
        TotalDue: "Total Devido",
        BillsFound: "Faturas Encontradas",
        DeselectAll: "Desmarcar Todas",
        SelectAll: "Selecionar Todas",
        ShowDetails: "Mostrar detalhes"
    },
    AssetsNewLocal: {
        Assignedon: "Atribuído em",
        Total: "Total",
        Assigned: "Atribuído",
        Remaining: "Restante",
        Available: "Disponível",
        NoSerialNumbers: "Nenhum número de série",
        UpdateExistingAssetDetails: "Atualizar detalhes do ativo existente",
        RegisterNewBusinessAsset: "Registrar um novo ativo comercial",
        BasicInformation: "Informações Básicas",
        AssetDetails: "Detalhes do Ativo",
        Quantity: "Quantidade",
        SerialNumbers: "Números de Série",
        SerialNumberPlaceholder: "Número de série",
        AddSerialNumber: "Adicionar Número de Série",
        SerialNumbersOptional: "Os números de série são opcionais. Você pode adicionar até",
        AssetImages: "Imagens do Ativo",
        AdditionalNotes: "Notas Adicionais",
        AdditionalNotesPlaceholder: "Quaisquer detalhes adicionais ou histórico de manutenção...",
        Updating: "Atualizando...",
        Adding: "Adicionando...",
        ITEquipmentPlaceholder: "ex. Equipamentos de TI",
        LoadingMoreActivities: "Carregando mais atividades...",
        AssignedAssets: "Ativos Atribuídos",
        Noassetsassignedstaffmember: "Nenhum ativo atribuído a este membro da equipe.",
        Assignassetstaff: "Atribuir um ativo ao funcionário",
        Returnassetfromstaff: "Devolver este ativo do funcionário",
        AssignmentDetails: "Detalhes da Atribuição",
        Serial: "Serial",
        ViewAssets: "Ver Todos os Ativos",
        ViewByStaff: "Ver por Equipe",
        AssignedHistory: "Histórico de Atribuições",
        Returned: "Devolvido",
        Returnedon: "Devolvido em",
        ReturnedBy: "Devolvido por",
        AssignedTo: "Atribuído a",
        NoHistoryRecords: "Nenhum registro de histórico",
        Selectstaffmemberviewtheirassets: "Selecione um membro da equipe para ver seus ativos.",
        Deleted: "DELETADO",
        searchPlaceholder: "Pesquisar ativo por nome ou número de série..."
    },
    InventoryCountLocale: {
        InventoryCount: "Contagem de Inventário",
        Viewinventorycountreport: "Ver relatório de contagem de inventário",
        ItemsCount: "Contagem de Itens",
        All: "Todos",
        InProgress: "Em Andamento",
        Submitted: "Enviado",
        awaitingreview: "Aguardando Revisão",
        EditInventoryCount: "Editar Contagem de Inventário",
        NewInventoryCount: "Nova Contagem de Inventário",
        Modifyinventorycountsheetdetails: "Modificar detalhes da planilha de contagem",
        Startanewinventorycountsheet: "Iniciar nova planilha de contagem",
        GeneralInformation: "Informações Gerais",
        Title: "Título",
        SaveChanges: "Salvar Alterações",
        Selectproductsforthisinventorycountsheet: "Selecionar produtos para esta planilha",
        InventoryCountDetails: "Detalhes da Contagem",
        Inventorycountsheetdetails: "Detalhes da planilha de contagem",
        Viewingdetailsforcountsheet: "Visualizando detalhes da planilha",
        Started: "Iniciado",
        TaskSheets: "Planilhas de Tarefas",
        Allitems: "Todos os itens",
        NotStarted: "Não Iniciado",
        Completed: "Concluído",
        Results: "Resultados",
        ViewResults: "Ver Resultados",
        DeleteInventoryCount: "Excluir Contagem de Inventário",
        Viewingtransactionandadjustments: "Visualizando logs de transações e ajustes de estoque",
        Productsadjusted: "Produtos ajustados",
        Assignee: "Responsável",
        Tasksheetdetails: "Detalhes da planilha de tarefa",
        Draft: "Rascunho",
        VariantQuantities: "Quantidades de Variantes",
        AssignedProducts: "Produtos Atribuídos",
        ReturnAsset: "Devolver Ativo",
        EditTasksheet: "Editar Planilha de Tarefa",
        NewTasksheet: "Nova Planilha de Tarefa",
        Updatetasksheetdetails: "Atualizar detalhes da planilha de tarefa",
        Starttasksheetforthisinventorycount: "Iniciar nova planilha de tarefa para esta contagem",
        TaskSheetInformation: "Informações da Planilha de Tarefa",
        SheetTitle: "Título da Planilha",
        Entersheettitle: "Digite o título da planilha",
        SubmissionResult: "Resultado da Submissão",
        ReviewChanges: "Revisar Alterações",
        Viewingsubmissionresultsforthisinventorycount: "Visualizando resultados da submissão para esta contagem",
        Reviewyourinventorycountbeforesubmitting: "Revise sua contagem de inventário antes de enviar"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Falha ao carregar contagens",
        NoInventoryCounts: "Nenhuma Contagem de Inventário",
        NoMatches: "Nenhuma Correspondência",
        Therearenoinventorycountswiththestatus: "Não há contagens de inventário com o status",
        Noinventorycountsfoundyoursearchterm: "Nenhuma contagem de inventário encontrada correspondente ao seu termo de busca.",
        Thereareinventorycountsrecordedyetforthisbusiness: "Ainda não há contagens de inventário registradas para este negócio."
    },
    StockinModalP: {
        StockInNow: "Dar Entrada no Estoque Agora",
        Settheopeningquantityforthisproductrightnow: "Defina a quantidade inicial para este produto agora.",
        Addinitialstock: "Adicionar estoque inicial?",
        dothislater: "Farei isso mais tarde",
        Productadded: "Produto adicionado!",
        isready: "está pronto.",
        SeeHowItWorks: "Ver Como Funciona",
        NoSalesOrdersFound: "Nenhuma Ordem de Venda Encontrada",
        NoPurchaseOrdersFound: "Nenhuma Ordem de Compra Encontrada",
        Startcreatingoutgoinginventoryrevenue: "Comece a criar ordens de venda para rastrear seu inventário de saída e receita.",
        Trackrestockssupplierplace: "Rastreie reabastecimentos de estoque e pedidos de fornecedores em um só lugar.",
        CreateSalesOrder: "Criar Ordem de Venda",
        CreatePurchaseOrder: "Criar Ordem de Compra",
    }
    ,
    dialy_report: "Relatório de Movimento Diário",
    Quotation: "Cotação",
    Quote: "Cotação",
    Assignee: "Responsável",
    dayStart: "Início do dia",

    ShowTotalAmount: "Valor Total",


    tutorial: {
        watchTitle: 'Assista aos tutoriais passo a passo',
        watchDesc: 'Saiba mais sobre o SimplyStock no nosso canal do YouTube',
        modalTitle: 'Fique à frente com o SimplyStock',
        modalDesc: 'Inscreva-se para obter novos tutoriais no momento em que eles forem lançados',
        feature1Title: 'Novos recursos passo a passo',
        feature1Sub: 'Cada nova atualização explicada com um pequeno vídeo — para que nunca perca o que há de novo',
        feature2Title: 'Vídeos de instruções rápidas',
        feature2Sub: 'Configure stock, faturas, acesso de pessoal e muito mais em menos de 5 minutos',
        feature3Title: 'Notificações por push instantâneas',
        feature3Sub: 'Seja notificado no momento em que um novo tutorial for publicado — aprenda no seu próprio ritmo',
        feature4Title: '100% grátis, sempre',
        feature4Sub: 'Todos os tutoriais são gratuitos para sempre — sem necessidade de login ou assinatura',
        subscribeBtn: 'Inscreva-se no SimplyStock',
        maybeLater: 'Talvez mais tarde'
    }
    ,
    dailyCashReport: {
        "title": "Relatório de Caixa Diário",
        "subtitle": "Quem pagou o quê, em qual data, e o que ainda é devido — agrupado do Detalhe de Vendas.",
        "totalSales": "Vendas totais",
        "cashReceived": "Total Recebido",
        "outstanding": "Pendente",
        "collectionRate": "Taxa de cobrança",
        "grandTotalAllDates": "TOTAL GERAL (todas as datas)",
        "totalLabel": "Total",
        "loading": "Carregando...",
        "noData": "Nenhum dado encontrado para o intervalo de datas selecionado.",
        "loadingMore": "Carregando mais..."
    },
    dailyCashReportColumns: {
        "date": "Data",
        "customer": "Cliente",
        "productsSold": "Produtos Vendidos",
        "products": "Produtos",
        "salesAmount": "Valor de Vendas",
        "sales": "Vendas",
        "received": "Total Recebido",
        "receivedShort": "Recebido",
        "debited": "Debitado no Livro-Razão",
        "due": "Devido",
        "paymentModes": "Modo(s) de Pagamento",
        "mode": "Modo"
    }
}


export default pt
